/**
 * @license
 * @qwik.dev/core 2.0.0-beta.45-dev+0da49c4
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as ze, isBrowser as Ve } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { getAsyncLocalStorage as Be } from "@qwik.dev/core/async-local-storage";

export { getAsyncLocalStorage as _getAsyncLocalStorage } from "@qwik.dev/core/async-local-storage";

import { p as We } from "@qwik.dev/core/preloader";

const Ue = !1;

const Qe = "2.0.0-beta.45-dev+0da49c4";

const Je = (t, ...n) => Ge(!1, t, ...n);

const Ye = (t, ...n) => Ge(!0, t, ...n);

const Ge = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

const Ze = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Ke = t => typeof t === "object" && t !== null;

const tr = t => Array.isArray(t);

const nr = t => typeof t === "string";

const er = t => typeof t === "function";

const rr = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Ge(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const ir = globalThis.__qwik__ ||= {};

const sr = ze ? ir.singletons ||= Object.create(null) : ir[Qe] ||= Object.create(null);

const or = t => Symbol.for(`qwik.${Qe}.${t}`);

const lr = (t, n) => {
    t in sr || (sr[t] = n());
    return sr[t];
};

const ur = t => sr[t];

if (ze) {
    class t {
        S=0;
    }
    const n = !Object.keys(new t).some(t => t.includes("probe"));
    const e = n ? "production" : "development";
    const s = `${Qe} (${e})`;
    const o = ir.version;
    if (o && o !== s) {
        throw rr(30, [ o, s ]);
    }
    ir.version = s;
    globalThis.__EXPERIMENTAL__ ??= new Proxy({}, {
        get: (t, n) => ur("experimental")?.[n]
    });
    const r = {
        each: __EXPERIMENTAL__.each,
        show: __EXPERIMENTAL__.show,
        pendingBoundary: __EXPERIMENTAL__.pendingBoundary,
        catchBoundary: __EXPERIMENTAL__.catchBoundary,
        valibot: __EXPERIMENTAL__.valibot,
        noSPA: __EXPERIMENTAL__.noSPA,
        insights: __EXPERIMENTAL__.insights,
        blockSSR: __EXPERIMENTAL__.blockSSR
    };
    typeof r.each === "boolean" && lr("experimental", () => r);
}

const cr = "<sync>";

const fr = t => typeof t === "function" && typeof t.getSymbol === "function";

const Ld = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const ar = "q:renderFn";

const hr = "q:componentHash";

const dr = "q:targetEl";

const pr = "⚡️";

const $r = "q:slot";

const yr = "q:sparent";

const wr = "q:s";

const vr = "[q\\:patch]";

const mr = "q:r";

const jd = "q:rp";

const br = "q:cc";

const _r = "q:style";

const gr = "style[q\\:style]";

const Er = gr + ",style[q\\:sstyle]";

const Sr = "q:sstyle";

const kr = "q:ctx";

const Rr = "q:brefs";

const Pr = (t, n) => t["qFuncs_" + n] || [];

const qr = "q:base";

const Ar = "q:container-island";

const Tr = "/" + Ar;

const Ir = "q:ignore";

const Mr = "/" + Ir;

const xr = "q:container";

const Nr = "/" + xr;

const Cr = "q:template";

const Or = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const jr = "http://www.w3.org/1999/xhtml";

const Lr = "http://www.w3.org/2000/svg";

const Fr = "http://www.w3.org/1998/Math/MathML";

const Xr = "qRender";

const Dr = "q-e:qvisible";

const Wr = "q:id";

const zr = "q:key";

const Vr = "q:props";

const Ur = "q:seq";

const Br = "q:seqIdx";

const Qr = "q:p";

const Hr = "q:ps";

const Yr = ":on";

const Gr = ":onIdx";

const Zr = ":onFlags";

const Kr = ":cursorBoundary";

const ti = ":nearestCursorBoundary";

const ni = ":";

const ei = "dangerouslySetInnerHTML";

const Fd = ze ? /*#__PURE__*/ lr("regSymbols", () => new Map) : void 0;

const ii = () => ({
    isServer: ze,
    importSymbol(t, n, e) {
        if (ze) {
            const t = Ld(e);
            const n = Fd.get(t);
            if (n) {
                return n;
            }
            throw rr(6, [ e ]);
        }
        if (!n) {
            throw rr(14, [ e ]);
        }
        if (!t) {
            throw rr(13, [ n, e ]);
        }
        const s = si(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const si = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(qr) ?? s, s);
    return new URL(e, o);
};

let oi = /*#__PURE__ */ ii();

const li = t => oi = t;

const ui = () => oi;

const Xd = () => oi.isServer;

/*@__INLINE__*/ const ci = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const fi = (t, n, e, s, o = !1) => {
    const r = ci(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const ai = (t, n, e) => {
    const s = ci(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const hi = (t, n, e) => ci(t, n, e) >= 0;

const di = t => t.nodeType === 1;

const pi = 100;

const $i = t => {
    try {
        return !!t && typeof t == "object" && typeof t.then === "function";
    } catch {
        return !1;
    }
};

const yi = (t, n, e) => {
    try {
        const s = t();
        return $i(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const wi = (t, n) => $i(t) ? t.then(n) : n(t);

const vi = t => new Promise(n => {
    setTimeout(n, t);
});

const mi = t => {
    throw t;
};

function t(t, n = mi) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!$i(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = pi;
    const r = async e => {
        for (;$i(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!$i(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const bi = t => {
    const n = t.yn;
    return n || t;
};

const Dd = t => t.xt;

const _i = /*#__PURE__*/ or("backRef");

class gi {
    [_i]=void 0;
}

const Ei = "q:type";

const Si = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Pi = 124;

const qi = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

const Ai = t => t === "foreignObject";

const Ti = t => t === "svg" || Ai(t);

const Ii = t => t === "math";

function n(t, e, s, o = !1) {
    const r = t.ownerDocument.createElementNS(s, e);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== ni && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let e = 0; e < t.childNodes.length; e++) {
            const i = t.childNodes[e];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(n(i, i.localName, s, o));
        }
    }
    return r;
}

const Mi = {
    elementNamespace: jr,
    elementNamespaceFlag: 0
};

function e(t, n) {
    const e = !t || !!Yl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Ai(Yl(t));
    let o = jr;
    let r = 0;
    const i = typeof n === "string" || wl(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Ti(t);
        }
        if (wl(t)) {
            return Ti(Yl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Lr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Ii(t);
        }
        if (wl(t)) {
            return Ii(Yl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Fr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Lr : e ? Fr : jr;
        r = t.flags & 1536;
    }
    Mi.elementNamespace = o;
    Mi.elementNamespaceFlag = r;
    return Mi;
}

const xi = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function r(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Ni(t.slice(s, -1));
        }
    }
    return null;
}

const Ni = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Ci(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Ci = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Oi = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const ji = /*#__PURE__*/ or("brand");

const Li = (t, n) => t != null && (typeof t === "object" || typeof t === "function") && (t[ji] & n) !== 0;

const Fi = (t, n) => {
    const e = t.prototype;
    e[ji] = (e[ji] || 0) | n;
    Object.defineProperty(t, Symbol.hasInstance, {
        value: t => Li(t, n)
    });
};

class Xi {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [_i]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

Fi(Xi, 256);

class Di extends Xi {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

Fi(Di, 512);

class Wi extends Di {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

Fi(Wi, 1024);

class zi extends Xi {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

Fi(zi, 2048);

const Vi = /*#__PURE__*/ lr("cursorQueue", () => []);

const Ui = /*#__PURE__*/ lr("pausedCursorQueue", () => []);

function i(t, n) {
    const e = $(n).priority;
    let s = Vi.length;
    for (let t = 0; t < Vi.length; t++) {
        const n = $(Vi[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Vi.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function s() {
    for (let t = 0; t < Vi.length; t++) {
        const n = Vi[t];
        let e = !1;
        for (let t = 0; t < Ui.length; t++) {
            const s = Ui[t];
            if (vu(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function o(t, n) {
    Ui.push(t);
    c(t, n, !0);
    n.o++;
}

function l(t, n) {
    f(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    i(n, t);
}

function u(t, n, e) {
    const s = $(e);
    if (!s || s === n) {
        return;
    }
    c(e, t, !1);
    f(e, t);
    p(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function c(t, n, e) {
    e || (t.flags &= -257);
    const s = Vi.indexOf(t);
    if (s !== -1) {
        Vi.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function f(t, n) {
    const e = Ui.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = Ui.length - 1;
    e !== s && (Ui[e] = Ui[s]);
    Ui.pop();
    n.o--;
    return !0;
}

const Bi = /*#__PURE__*/ lr("cursorDatas", () => new WeakMap);

const Qi = ":nodeProps";

const Hi = ":nodeDiff";

const Ji = ":errorData";

const Yi = ":signal";

const Gi = ":inlineComponentData";

const Zi = /*#__PURE__*/ lr("pendingQwikLoaderEvents", () => new WeakMap);

function a(t, n) {
    let e = Zi.get(t);
    e || Zi.set(t, e = []);
    e.includes(n) || e.push(n);
}

function h(t) {
    const n = Zi.get(t);
    n && Zi.delete(t);
    return n;
}

function d(t, n, e) {
    n.position = e;
    e && $n(e) && function s(t, n, e) {
        const s = $(e);
        if (!s || s === n) {
            return;
        }
        c(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = h(n);
            if (s) {
                for (let n = 0; n < s.length; n++) {
                    a(t, s[n]);
                }
            }
            const o = n.extraPromises;
            if (o && o.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...o) : t.extraPromises = o;
            }
            p(t, n);
        })(n, s);
    }(t, n, e);
}

function p(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.pendingBoundary && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function $(t) {
    return Bi.get(t) ?? null;
}

const Ki = /*#__PURE__*/ or("CONST");

const ts = /*#__PURE__*/ or("VAR");

const ns = /*#__PURE__*/ or("OWNER");

const es = /*#__PURE__*/ or("PROPS_HANDLER");

const rs = /*#__PURE__*/ or("IMMUTABLE");

const is = /*#__PURE__*/ or("UNINITIALIZED");

const ss = [];

const os = {};

Object.freeze(ss);

Object.freeze(os);

function y(t) {
    return new Proxy({}, new ls(t));
}

class ls {
    owner;
    dt=void 0;
    k=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Ki) {
            return this.owner.constProps;
        }
        if (n === ts) {
            return this.owner.varProps;
        }
        if (n === ns) {
            return this.owner;
        }
        if (n === es) {
            return this;
        }
        let e;
        if (n === "children") {
            e = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            e = fs(this.owner, n);
            n in this.owner.varProps && us(this, n);
        }
        return e instanceof Xs ? e.value : e;
    }
    set(t, n, e) {
        if (n === ns) {
            this.owner = e;
        } else if (n === "children") {
            this.owner.children = e;
        } else if (n === Ki) {
            this.owner.constProps = e;
        } else if (n === ts) {
            this.owner.varProps = e;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === os ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== e) {
                this.owner.varProps[n] = e;
                cs(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && cs(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Ki || n === ts) {
            return !0;
        }
        const e = n in this.owner.varProps;
        if (typeof n === "string") {
            e && us(this, n);
            if (typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
        }
        return e || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const us = (t, n) => {
    const e = na();
    e && t.k === null && e.k && (t.k = e.k);
    const s = e?.dn;
    s && Cn(t.owner._proxy, n, t, s);
};

const cs = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.dt, n);
    e && ju(t.k, t, e);
    return !!e;
};

const fs = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const as = (t, n) => hs(t)?.[n] || ds(t)?.[n] || null;

const hs = t => {
    if (!t) {
        return null;
    }
    return ts in t ? "children" in t ? {
        ...t[ts],
        children: t.children
    } : t[ts] : t;
};

const ds = t => {
    if (!t) {
        return null;
    }
    return Ki in t ? t[Ki] : null;
};

const ps = t => t && ts in t;

const $s = /*#__PURE__*/ or("invalid");

class ys {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

Fi(ys, 524288);

const ws = /*#__PURE__*/ or("store.target");

const vs = /*#__PURE__*/ or("store.handler");

const ms = /*#__PURE__*/ or("store.all");

function w(t, n, e) {
    t[_i] || (ze && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Rr, new Map) : t[_i] = new Map);
    const o = t[_i];
    let r = o.get(n);
    if (!r) {
        r = new ys(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const bs = (t, n) => (e, s) => {
    const o = Xe();
    o.dn = w(t, ":");
    o.k = n || void 0;
    return je(o, () => {
        if (er(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Mu(e)) {
            return e.value;
        }
        if (Ke(e) && Hu(e)) {
            Cn(Vu(e), ms, zu(e), o.dn);
            return e;
        }
        throw rr(2);
    });
};

class _s {
    Wt;
    dt=void 0;
    k=null;
    wn=null;
    constructor(t, n) {
        this.k = t || na()?.k || null;
        this.Wt = n;
    }
    trigger() {
        ju(this.k, this, this.dt);
    }
    force() {
        ju(this.k, this, this.dt);
    }
    get untrackedValue() {
        return this.Wt;
    }
    set untrackedValue(t) {
        this.Wt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = na();
        if (!n) {
            return t;
        }
        this.k === null && (this.k = n.k);
        const e = n.dn;
        if (e) {
            const t = ze;
            const s = this.dt ||= new Set;
            const o = __EXPERIMENTAL__.pendingBoundary && t;
            xu(s, e);
            Nu(e, this);
            if (t) {
                const t = Ou(n.k, this.k);
                o && t?.vn?.(this, e, null);
                Cu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Wt) {
            this.Wt = t;
            ju(this.k, this, this.dt);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Wt
        };
    }
}

Fi(_s, 1);

class gs {
    mn;
    bn=null;
    _n=!1;
    gn=!0;
    constructor(t, n, e) {
        this.mn = t;
        if (n !== void 0) {
            this.info = n;
            this.En = e;
        }
    }
    get track() {
        if (!this.Sn) {
            const t = bs(this.mn, this.mn.k);
            this.Sn = (n, e) => {
                if (this.mn.kn) {
                    throw rr(39);
                }
                return t(n, e);
            };
        }
        return this.Sn;
    }
    get abortSignal() {
        const t = this.Rn ||= new AbortController;
        this._n && t.abort();
        return t.signal;
    }
    cache() {}
    get previous() {
        const t = this.mn.Wt;
        if (t !== $s) {
            return t;
        }
    }
    cleanup=t => {
        typeof t === "function" && (this.Pn ||= []).push(t);
    };
}

class Es extends _s {
    zt;
    h;
    [_i]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || na()?.k, $s);
        this.zt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Wt = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.Bt = r;
            this.Qt = [];
        }
        s.timeout && (this.Ht = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
    }
    clear() {
        this.Wt = $s;
        this.invalidate();
    }
    invalidate(n) {
        if (this.kn) {
            return;
        }
        if (arguments.length > 0) {
            this.qn = n;
            this.En = this.En === void 0 ? 1 : this.En + 1;
        }
        if (this.h & 512) {
            this.An(!0);
            return;
        }
        this.h |= 1;
        const e = Xe();
        e.k = this.k || void 0;
        const s = t(Le.bind(this, e, this.$));
        $i(s) && s.catch(t => {
            this.k ? this.k.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.qn = void 0;
            if (this.Qt) {
                for (let t = 0; t < this.Qt.length; t++) {
                    this.Qt[t].gn = !1;
                }
            } else {
                this.Tn && (this.Tn.gn = !1);
            }
            super.value = t;
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.$();
        if (this.Tn?.bn) {
            if (this.Wt === $s || ze) {
                throw this.Tn?.bn;
            }
            return this.Wt;
        }
        if (this.Vt) {
            throw this.Vt;
        }
        if (ze && this.h & 64 && this.Wt === $s) {
            throw rr(35);
        }
        return this.Wt;
    }
    set untrackedValue(t) {
        this.Wt = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = na();
        if (n && (this.k ||= n.k || null)) {
            const t = n.dn;
            if (t) {
                xu(this.vt ||= new Set, t);
                Nu(t, this);
                Cu(t, this.k);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Ut) {
            this.Ut = t;
            ju(this.k, this, this.vt);
        }
    }
    get untrackedPending() {
        this.$();
        if (ze && this.Tn?.bn) {
            throw this.Tn?.bn;
        }
        return !!this.Ut;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = na();
        if (n && (this.k ||= n.k || null)) {
            const t = n.dn;
            if (t) {
                xu(this.bt ||= new Set, t);
                Nu(t, this);
                Cu(t, this.k);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.Vt) {
            this.Vt = t;
            ju(this.k, this, this.bt);
        }
    }
    get untrackedError() {
        this.$();
        if (ze && this.Tn?.bn) {
            throw this.Tn?.bn;
        }
        return this.Vt;
    }
    An(t) {
        if (this.kn) {
            return;
        }
        this.h |= 1;
        t && (this.dt?.size || this.vt?.size || this.bt?.size) && Promise.resolve().then(() => this.$());
    }
    abort(t) {
        this.Tn && this.In(this.Tn, t);
    }
    _t() {
        if (!(this.h & 32) || this.Mn()) {
            return;
        }
        if (!Ve) {
            return;
        }
        setTimeout(() => {
            this.Mn() || this.abort();
        });
    }
    async promise() {
        await t(() => this.$());
        for (;this.Tn?.bn; ) {
            await (this.Tn?.bn);
        }
    }
    $() {
        if (this.kn || !(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.xn();
        }
        const n = this.zt;
        Iu(n);
        const e = this.Tn;
        if (e && !e._n) {
            e._n = !0;
            e.Rn?.abort();
            this.Nn(e);
        }
        const s = new gs(this, this.qn, this.En);
        this.Tn = s;
        let o;
        try {
            o = this.Cn(n.resolved, s);
        } catch (t) {
            if ($i(t)) {
                throw t;
            }
            s.En === this.En && (this.qn = void 0);
            this.h &= -2;
            this.On(s, t);
            return;
        }
        if ($i(o)) {
            this.h |= 512;
            this.h &= -2;
            let n = o;
            const e = () => {
                const t = n ?? this.Cn(this.zt.resolved, s);
                n = void 0;
                return t;
            };
            s.bn = this.jn(s, () => t(e));
            return;
        }
        s.En === this.En && (this.qn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    Cn(t, n) {
        if (this.kn) {
            throw rr(39);
        }
        const e = t;
        if (this.h & 1024) {
            let t = na();
            t?.dn && (t = {
                ...t,
                dn: void 0
            });
            return Le(t, e, [ n ]);
        }
        const s = this.k ||= na()?.k || null;
        const o = w(this, ".");
        s && qn(s, o);
        const r = Xe();
        r.k = s || void 0;
        r.dn = o;
        return Le(r, e, [ n ]);
    }
    xn() {
        if (ze && this.h & 64) {
            this.Ut = !0;
            this.k?.serializationCtx.Ae.add(this);
            return;
        }
        this.h &= -2;
        const t = this.Tn;
        t && this.In(t);
        const n = this.Bt === 0 ? Infinity : this.Bt ?? 1;
        if (this.Qt ? this.Qt.length >= n : t?.bn) {
            this.h |= 1;
            return;
        }
        const e = this.En;
        const s = new gs(this, this.qn, e);
        this.Tn = s;
        this.Qt && this.Qt.push(s);
        s.bn = this.Ln(s);
    }
    async Ln(n) {
        let e = this.zt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.zt.resolve();
            if (this.kn || n.Rn?.signal.aborted) {
                n.bn = null;
                return;
            }
        }
        this.Ht && (this.Fn = setTimeout(() => {
            const t = Error(`timeout ${this.Ht}ms`);
            this.On(n, t);
            n.Rn?.abort(t);
        }, this.Ht));
        return this.jn(n, () => t(() => this.Cn(e, n)));
    }
    async jn(t, n) {
        try {
            const e = n();
            let s;
            if ($i(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.bn = null;
            if (t.gn) {
                const n = this.Qt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].gn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.bn = null;
            this.On(t, n);
        }
        if ((() => t === this.Tn)() && !this.kn) {
            clearTimeout(this.Fn);
            t.En === this.En && (this.qn = void 0);
            this.h & 1 ? this.$() : this.untrackedPending = !1;
        }
    }
    On(t, n) {
        if (t !== this.Tn || !t.gn) {
            return;
        }
        t.gn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = $s;
    }
    $dispose() {
        if (this.kn) {
            return;
        }
        this.kn = !0;
        this.h &= -2;
        clearTimeout(this.Fn);
        this.k && Pn(this.k, this);
        const t = new Set(this.Qt);
        this.Tn && t.add(this.Tn);
        for (const n of t) {
            n.gn = !1;
            this.In(n);
        }
    }
    async Xn() {
        clearTimeout(this.Fn);
        const t = this.Tn;
        t && this.In(t);
        this.Qt ? await Promise.all(this.Qt.map(t => t.bn)) : await (t?.bn);
    }
    Mn() {
        return !!(this.dt?.size || this.vt?.size || this.bt?.size);
    }
    In(t, n) {
        if (t._n) {
            return;
        }
        t._n = !0;
        t.Rn?.abort(n);
        t.bn = wi(t.bn, () => this.Dn(t));
    }
    Nn(t) {
        const n = t.Pn;
        const e = t => {
            const n = this.k?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    $i(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Dn(t) {
        const n = () => {
            t.bn = null;
            const n = this.Qt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.$();
        };
        const e = this.Nn(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

Fi(Es, 4);

const Ss = t => (n, ...e) => t.call(null, ja(n), ...e);

class ks extends Es {
    constructor(t, n) {
        super(t, n, 17);
    }
    Wn=!1;
    $() {
        if (!(this.h & 1)) {
            return;
        }
        Iu(this.zt);
        const t = sa(this.zt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Wt === $s ? e : this.Wt;
        const r = la(() => this.Wn ? s?.(o) || o : n(o), this, ".", this.k);
        this.Wn = !0;
        this.h &= -2;
        const i = this.Wn && r !== "undefined" || r !== this.Wt;
        if (i) {
            this.Wt = r;
            ju(this.k, this, this.dt);
        }
    }
}

Fi(ks, 16);

class Rs extends Es {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

Fi(Rs, 8);

const Ps = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.$();
};

const qs = (t, n) => new Es(n?.container || null, t, Fu(n?.serializationStrategy || "always"), n);

const As = (t, n) => new Rs(n?.container || null, t, Fu(n?.serializationStrategy || "always"), n);

const Ts = t => new ks(null, t);

const Is = t => new _s(null, t);

const Ms = /*#__PURE__*/ Ss(qs);

const xs = Ss(Ts);

const Ns = t => t.value;

const Cs = (t, n) => t[n];

const Os = t => {
    if (t.length === 1) {
        if (Mu(t[0])) {
            return t[0].wn ||= new Xs(null, Ns, t, null);
        }
        if (Hu(t[0])) {
            return new Xs(null, Ns, t, null);
        }
        return t[0].value;
    }
    return new Xs(null, Cs, t, null);
};

const js = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Ke(n)) {
        return n[e];
    }
    if (Mu(n)) {
        if (n instanceof Xs) {
            return n;
        }
        return Os(t);
    }
    if (ps(n)) {
        const s = n[Ki];
        const o = n[ts];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Ls(n, t);
        }
    } else {
        const s = Vu(n);
        if (s) {
            const n = s[e];
            return Ls(n, t);
        }
    }
    return n[e];
};

const Ls = (t, n) => Mu(t) ? t : Os(n);

const Fs = (t, n) => {
    const e = js(t, n);
    if (e === rs) {
        return t[n];
    }
    return e;
};

class Xs extends _s {
    ft;
    ct;
    qt;
    h;
    R=void 0;
    [_i]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, $s);
        this.ft = e;
        this.ct = n;
        this.qt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.$();
        } catch (t) {
            if (this.k && this.R) {
                this.k.setHostProp(this.R, Yi, this);
                vn(this.k, this.R, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            ju(this.k, this, this.dt);
        }
    }
    get untrackedValue() {
        this.$();
        return this.Wt;
    }
    $() {
        if (!(this.h & 1)) {
            return;
        }
        const t = la(() => this.ct(...this.ft), this, ".", this.k);
        this.h &= -3;
        const n = t !== this.Wt;
        if (n) {
            this.h |= 2;
            this.Wt = t;
        }
    }
    lt() {
        return this.ct === Ns && Mu(this.ft[0]) ? this.ft[0] : this;
    }
    set value(t) {
        throw rr(31);
    }
    get value() {
        return super.value;
    }
}

Fi(Xs, 2);

class Ds {
    data;
    constructor(t) {
        this.data = t;
    }
}

Fi(Ds, 128);

const Ws = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

Object.prototype.hasOwnProperty;

class zs {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Ws(n) ? os : n;
        this.constProps = !e || Ws(e) ? null : e;
    }
    get props() {
        return this._proxy ||= y(this);
    }
}

Fi(zs, 64);

const Vs = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Us = t => t instanceof zs;

const Bs = (t, n, e) => {
    if (typeof t === "string") {
        const s = Ie(n);
        return Gf(s, () => {
            Sa(ka(s, t));
            return e();
        });
    }
    return e();
};

function v(t, n) {
    return Bs(this, n, () => {
        const t = ga._[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function m(t, n) {
    return Bs(this, n, () => {
        const t = ga._[0];
        t.value = n.checked;
    });
}

function b(t, n) {
    return Bs(this, n, () => {
        const t = ga._;
        if (t) {
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                e instanceof Rs && e.h & 64 && e.$();
            }
        }
    });
}

const Qs = "bind:value";

const Hs = "bind:checked";

const Js = "passive:";

const Ys = "preventdefault:";

const Gs = Object.prototype.hasOwnProperty;

const Zs = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Ni(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Ks = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Ni(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Ni(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Ni(t.slice(11, -1));
    }
    return null;
};

const to = (t, n, e, s, o = !1) => {
    let i = t;
    let c = o;
    for (let t = 0; t < n.length; t++) {
        const o = n[t];
        const l = Ks(o);
        const u = r(o, s.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = e.get(u);
            (t === void 0 || t < e.get(o)) && (i[u] = i[o]);
            delete i[o];
        }
    }
    return i;
};

const no = (t, n, e, s, o, r, i) => new zs(t, n, e, s, o, r, !1, i);

const eo = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Js)) {
                    r.push(o);
                    t.add(Ni(o.slice(8)));
                } else {
                    o.startsWith(Ys) ? h.push(o) : Ks(o) !== null ? s.push(o) : o === Hs ? a = e[o] : o === Qs && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Js)) {
                    i.push(s);
                    t.add(Ni(s.slice(8)));
                } else {
                    s.startsWith(Ys) ? d.push(s) : Ks(s) !== null ? o.push(s) : s === Hs ? a = n[s] : s === Qs && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Zs(e, r, h, t, l);
            l = l || e !== n;
            e = to(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Zs(n, i, d, t, u);
            u = u || n !== e;
            n = to(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Gs.call(n, Hs) && delete n[Hs];
                if (e && Gs.call(e, Hs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Hs];
                }
                n.checked = a;
                const t = Aa(null, "_chk", m, null, [ a ]);
                if (e && Gs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Vs(n, "q-e:input", t) || c;
                }
                c = Vs(n, "q-e:input", t) || c;
            } else if (f) {
                n && Gs.call(n, Qs) && delete n[Qs];
                if (e && Gs.call(e, Qs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Qs];
                }
                n.value = f;
                const t = Aa(null, "_val", v, null, [ f ]);
                if (e && Gs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Vs(n, "q-e:input", t) || c;
                }
                c = Vs(n, "q-e:input", t) || c;
            }
        }
        if (n && Gs.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Gs.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new zs(t, n, e, s, o, r, c || !0, i);
};

const ro = (t, n, e, s) => lo(t, n, s);

const io = (t, n, e, s, o) => lo(t, {
    ...e,
    ...n
}, o);

const so = (t, n, e, s, o, r) => lo(t, {
    ...e,
    ...n,
    children: s
}, r);

const oo = t => t.children;

const lo = (t, n, e, s, o) => eo(t, n, null, null, 0, e, o);

const uo = lo;

const co = lo;

function _(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return eo(t, n, null, s.children, 0, o);
}

const fo = /*#__PURE__*/ lr("Fragment", () => t => t.children);

const ao = (t, n) => new zs(oo, null, null, t.children, 0, n);

const ho = /*#__PURE__*/ lr("Slot", () => t => no(oo, null, {
    [wr]: ""
}, t.children, 0, t.name ?? ""));

const po = /*#__PURE__*/ or("skip render");

const $o = /*#__PURE__*/ lr("SSRRaw", () => () => null);

const yo = /*#__PURE__*/ lr("SSRComment", () => () => null);

const wo = /*#__PURE__*/ lr("SSRStreamBlock", () => t => t.children);

const vo = /*#__PURE__*/ lr("SSRStream", () => (t, n) => lo(ao, {
    children: lo(mo, t)
}, n));

const mo = () => null;

let bo = null;

let _o = null;

function g(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    _o || (_o = t.setAttributeNS);
                    _o.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            bo || (bo = t.setAttribute);
            bo.call(t, n, e);
        })(t, n, e);
    }
}

function E(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const go = Object.prototype.hasOwnProperty;

const Eo = Object.prototype.propertyIsEnumerable;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

function k(t) {
    if (t) {
        for (const n in t) {
            if (S(n)) {
                return !0;
            }
        }
    }
    return !1;
}

const So = (t, n = [], e = {}) => {
    if (!Ke(t) || !ps(t)) {
        if (t == null) {
            throw new TypeError(`Cannot destructure '${t}' as it is ${t}.`);
        }
        const s = Object(t);
        const o = Reflect.ownKeys(s);
        for (let t = 0; t < o.length; t++) {
            const r = o[t];
            !Eo.call(s, r) || typeof r !== "symbol" && n.includes(r) || Object.defineProperty(e, r, {
                value: s[r],
                enumerable: !0,
                configurable: !0,
                writable: !0
            });
        }
        return e;
    }
    let s = null;
    const o = t[Ki];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[ts];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return y(new zs(null, r, s, null, 0, null));
};

function R(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && go.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Xs) {
            return ua(n, t, ":", e);
        }
    }
    return fs(n, "name") || "";
}

const ko = t => pr + t;

const Ro = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + ko(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Po = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const qo = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Ao = t => {
    if (!t) {
        return "";
    }
    if (nr(t)) {
        return t.trim();
    }
    const n = [];
    if (tr(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Ao(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const To = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const Io = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (tr(t)) {
            throw rr(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(To(e) + ":" + xo(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

const Mo = t => t != null ? t + "" : null;

function P(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Ao(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = Io(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = Mo(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const xo = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Po.has(t))(t)) {
        return n + "px";
    }
    return n;
};

class No {
    target;
    constructor(t) {
        this.target = t;
    }
}

Fi(No, 65536);

class Co {
    target;
    constructor(t) {
        this.target = t;
    }
}

Fi(Co, 131072);

class Oo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

Fi(Oo, 16384);

class jo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

Fi(jo, 262144);

class Lo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

Fi(Lo, 32768);

const Fo = t => new No(t);

const Xo = t => new Co(t);

const Do = (t, n) => new Oo(t, n);

const Wo = (t, n, e) => new jo(t, n, e);

const zo = (t, n, e, s = null, o = !1) => new Lo(t, n, e, s, o);

const Vo = () => {
    const t = ra();
    const n = t.R;
    const e = n;
    let s = t.k.getHostProp(e, Ur);
    if (s === null) {
        s = [];
        t.k.setHostProp(e, Ur, s);
    }
    let o = t.k.getHostProp(e, Br);
    o === null && (o = 0);
    t.k.setHostProp(e, Br, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Uo = t => {
    const n = er(t) && !za(t) ? je(void 0, t) : t;
    return Is(n);
};

const Bo = t => Qo(Uo, t);

const Qo = (t, ...n) => {
    const {val: e, set: s} = Vo();
    if (e != null) {
        return e;
    }
    t = er(t) && !za(t) ? sa(t, ...n) : t;
    return s(t);
};

function q(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    let e = null;
    let s = n;
    for (;s && !e; ) {
        e = I(s);
        s = s.slotParent || s.parent;
    }
    if (!e) {
        return;
    }
    const o = t.boundaries ||= [];
    if (!o.includes(e)) {
        o.push(e);
        e.value++;
    }
}

function A(t) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return null;
    }
    return El(t, Kr, null) || null;
}

function T(t) {
    M(t, null);
}

function I(t) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return null;
    }
    return El(t, ti, null) || A(t);
}

function M(t, n) {
    __EXPERIMENTAL__.pendingBoundary && Sl(t, ti, n);
}

function x(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    M(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        x(s, A(s) || n);
    }
}

const Ho = t => {
    if (t.Xn) {
        try {
            t.Xn();
        } catch (t) {
            Je(t);
        }
        t.Xn = null;
    }
};

function N(n, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const t = Ie(s);
        return Gf(t, () => N(n, e, s, ia(e, s, t)));
    }
    const r = o.k;
    const i = o.R;
    ql(r, i);
    let c = n;
    if (i.flags & 64) {
        let t;
        if (!(i.flags & 128)) {
            t = !0;
            i.flags |= 128;
        }
        const o = t ? r.q : null;
        const l = El(i, Qr, o);
        if (l !== null) {
            c = () => n(e, s, l);
        } else {
            const t = El(i, Hr, o);
            t !== null && (c = () => n(e, s, ...t));
        }
    }
    return t(() => {
        if (!(i.flags & 32)) {
            return Le(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i, "event"));
}

function C(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Ie(n);
    return Gf(e, () => {
        const s = ia(t, n, e);
        typeof this === "string" && Sa(ka(s.k, this));
        const o = ga._[0];
        return N(o, t, n, s);
    });
}

function O(t) {
    return t.T === t.M ? t.N : null;
}

function j(t) {
    return t.O || O(t);
}

function L(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = O(t);
    return e === o ? null : e;
}

const Jo = Object.prototype.hasOwnProperty;

function F(t, n, e, s, o, r) {
    Sl(n, e, r);
    mn(t, zo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function X(t, n, e, s) {
    return {
        k: t,
        j: n,
        L: e,
        X: s,
        D: [],
        W: [],
        U: [],
        T: null,
        O: null,
        B: null,
        N: null,
        M: null,
        H: null,
        J: null,
        Y: null,
        G: null,
        Z: null,
        K: 0,
        tt: 0,
        nt: !0,
        et: !1,
        rt: {
            it: new Ds({
                X: s,
                st: !0
            }),
            ot: new Ds({
                X: s,
                st: !1
            })
        }
    };
}

function D(t, n, e, s, o) {
    const r = t ?? X(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.k = n;
        t.j = e;
        t.L = s;
        t.X = o;
        t.rt.it.data.X = o;
        t.rt.ot.data.X = o;
        t.W.length = 0;
        t.U.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Yo = (t, n, e, s, o, r, i) => W(D(i, t, n, o, r), e, s);

const Go = (t, n, e, s, o, r, i, c, l = !1, u) => W(D(u, t, n, i, c), e, s, o, r, l);

function W(t, n, e, s = Kl(e), o = null, r = !1) {
    z(t, n, e, s, o, r);
    const i = K(t);
    if ($i(i)) {
        return i.finally(() => {
            tt(t);
        });
    }
    tt(t);
}

function z(t, n, e, s = Kl(e), o = null, r = !1) {
    const i = t.et;
    t.et = r || i;
    t.T = e;
    t.B = null;
    t.O = s;
    t.N = o;
    t.M = e;
    H(t, n, !0);
    try {
        if (t.T.flags & 32) {
            return;
        }
        for (;t.D.length; ) {
            for (;t.K < t.tt; ) {
                if (typeof t.Z === "string") {
                    mt(t, t.Z);
                } else if (typeof t.Z === "number") {
                    mt(t, t.Z + "");
                } else if (t.Z && typeof t.Z === "object") {
                    if (Us(t.Z)) {
                        const n = t.Z.type;
                        if (typeof n === "string") {
                            rt(t);
                            at(t, t.Z, n);
                            const e = t.Z.constProps && Jo.call(t.Z.constProps, ei) || Jo.call(t.Z.varProps, ei);
                            e ? t.B || nt(t, !1) : B(t, t.Z.children, !0);
                        } else if (typeof n === "function") {
                            if (n === fo) {
                                rt(t);
                                $t(t, "F", t.Z.key);
                                B(t, t.Z.children, !0);
                            } else if (n === ho) {
                                rt(t);
                                G(t) || B(t, t.Z.children, !0);
                            } else if (n === gt) {
                                Y(t);
                                B(t, t.Z.children, !0, !0);
                            } else if (n === yo) {
                                et(t);
                            } else if (n === $o) {
                                et(t);
                            } else {
                                rt(t);
                                yt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Z)) {
                        B(t, t.Z, !1);
                    } else if (Mu(t.Z)) {
                        $t(t, "S", null);
                        const n = t.Z instanceof Xs ? t.Z.lt() : t.Z;
                        const e = t.O?.[_i]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Xs && (s = Nt(e, n));
                        if (!s) {
                            const e = t.B || t.O;
                            B(t, V(t, () => ua(n, e, ".", t.k)), !0);
                        }
                    } else if ($i(t.Z)) {
                        $t(t, "A", null);
                        t.W.push(t.Z, t.B || t.O);
                    }
                } else {
                    t.Z === po || mt(t, "");
                }
                U(t);
            }
            et(t);
            Z(t);
            Q(t);
        }
    } finally {
        t.et = i;
    }
}

function V(n, e) {
    try {
        return e();
    } catch (s) {
        if ($i(s)) {
            const o = s.then(() => t(e));
            n.W.push(o, n.B || n.O);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.nt) {
        t.nt = !0;
        return;
    }
    t.K++;
    if (t.K < t.tt) {
        t.Z = t.G[t.K];
    } else if (t.D.length > 0 && t.D[t.D.length - 1] === !1) {
        return Q(t);
    }
    t.B !== null ? t.B = null : t.O = L(t, t.O);
}

function B(t, n, e, s = !1) {
    if (!s && (n == null || e && tr(n) && n.length === 0)) {
        nt(t);
        return;
    }
    H(t, n, e);
    if (e) {
        const n = !s && t.et || !!t.B || !Kl(t.O);
        t.et = n;
        t.Y = null;
        t.H = null;
        t.J = null;
        t.T = t.B || t.O;
        t.O = Kl(t.T);
        t.B = null;
    }
    t.nt = !1;
}

function Q(t) {
    const n = t.D.pop();
    if (n) {
        t.et = t.D.pop();
        t.Y = t.D.pop();
        t.H = t.D.pop();
        t.J = t.D.pop();
        t.B = t.D.pop();
        t.O = t.D.pop();
        t.T = t.D.pop();
    }
    t.Z = t.D.pop();
    t.tt = t.D.pop();
    t.K = t.D.pop();
    t.G = t.D.pop();
    U(t);
}

function H(t, n, e) {
    t.D.push(t.G, t.K, t.tt, t.Z);
    e && t.D.push(t.T, t.O, t.B, t.J, t.H, t.Y, t.et);
    t.D.push(e);
    if (Array.isArray(n)) {
        t.K = 0;
        t.tt = n.length;
        t.G = n;
        t.Z = t.tt > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.K = 0;
        t.Z = null;
        t.G = null;
        t.tt = 0;
    } else {
        t.K = 0;
        t.Z = n;
        t.G = null;
        t.tt = 1;
    }
}

function J(t) {
    if (t.B) {
        return j(t);
    }
    return L(t, t.O) || O(t);
}

function Y(t) {
    const n = t.Z;
    const e = n.key;
    t.O = El(t.T, e, n => Ml(t.k.rootVNode, n));
    t.O = t.O && t.O.flags & 32 ? null : t.O;
    if (t.O == null) {
        t.B = $l();
        Sl(t.B, $r, e);
        t.B.slotParent = t.T;
        Sl(t.T, e, t.B);
    }
}

function G(t) {
    const n = t.Z;
    const e = Ru(t.T);
    const s = R(e, n, t.k);
    const o = fs(n, Kr) || null;
    const r = e ? El(e, s, null) : null;
    if (r == null) {
        t.B = $l();
        Sl(t.B, $r, s);
        Sl(t.B, Kr, o);
        x(t.B, o);
        e && Sl(e, s, t.B);
        Ul(t.j, t.T, t.B, J(t));
        return !1;
    }
    if (r === t.O) {} else {
        const n = r.parent;
        t.B = r;
        Sl(t.B, $r, s);
        Sl(t.B, Kr, o);
        x(t.B, o);
        e && Sl(e, s, t.B);
        Vl(t.j, t.B);
        Ul(t.j, t.T, t.B, J(t));
        n && wl(n) && !n.firstChild && Yl(n) === Cr && Hl(t.j, n.parent, n, !0);
    }
    return !0;
}

function Z(t) {
    const n = t.Y;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            kt(t.k, t.j, e, t.L);
            Hl(t.j, t.T, e, !0);
        }
        n.clear();
        t.Y = null;
    }
    t.O = null;
}

function K(t) {
    for (;t.W.length; ) {
        const n = t.W.shift();
        const e = t.W.shift();
        if ($i(n)) {
            return n.then(n => {
                z(t, n, e);
                return K(t);
            }).catch(n => {
                t.k.handleError(n, e);
                return K(t);
            });
        }
        z(t, n, e);
    }
    if (t.U.length) {
        const n = t.U.splice(0);
        return Promise.all(n).then(() => K(t));
    }
}

function tt(t) {
    t.j = null;
    t.L = null;
}

function nt(t, n = !0) {
    const e = t.O && Kl(t.O);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            kt(t.k, t.j, s, t.L);
            s = s.nextSibling;
        }
        Jl(t.j, t.O, e, n);
    }
}

function et(t) {
    const n = O(t);
    if (t.O !== null && t.O !== n) {
        for (;t.O && t.O !== n; ) {
            const n = t.O;
            t.O = L(t, t.O);
            if (t.T === n.parent) {
                kt(t.k, t.j, n, t.L);
                Hl(t.j, t.T, n, !0);
            }
        }
    }
}

function rt(t) {
    if (t.O !== null && bl(t.O)) {
        const n = t.O;
        t.O = L(t, t.O);
        Hl(t.j, t.T, n, !0);
    }
}

function it(t, n, e) {
    if (Mu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw rr(15, [ e ]);
}

function st(n, e, s, o, r) {
    return t(() => ua(o, e, s, n, r));
}

function ot(t, n, e, s, o) {
    const r = t.X;
    const i = s.then(t => g(n, e, P(e, t, r), o));
    t.U.push(i);
}

function lt(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(xr, "html");
    }
}

function ut(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ct(t, n, s, o) {
    const r = function i(t, n) {
        const s = Ql(t.T, !0);
        const o = e(s, n);
        const r = document;
        const i = o.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(o.elementNamespace, n);
        t.B = hl(i, n);
        t.B.flags |= o.elementNamespaceFlag;
        return i;
    }(t, s);
    const c = t.B;
    const l = (c.flags & 512) !== 0;
    const {constProps: u} = n;
    if (u) {
        for (const n in u) {
            let e = u[n];
            if (xi(n)) {
                ft(n, e, r, c, t);
                continue;
            }
            if (n === "ref" && it(e, r, o)) {
                continue;
            }
            Mu(e) && (e = st(t.k, t.B, n, e, t.rt.it));
            if ($i(e)) {
                ot(t, r, n, e, l);
                continue;
            }
            if (n === ei) {
                lt(r, e);
                continue;
            }
            if (s === "textarea" && n === "value" && ut(r, e)) {
                continue;
            }
            g(r, n, P(n, e, t.X), l);
        }
    }
    const f = n.key;
    f && (t.B.key = f);
    if (t.X) {
        const e = Jo.call(n.varProps, "class") || n.constProps && Jo.call(n.constProps, "class");
        e || r.setAttribute("class", t.X);
    }
    Fl(t.j, t.T, t.B, j(t));
}

function ft(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(N.bind(null, n));
                }
            } else {
                e && s.push(N.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = N.bind(null, n));
    }
    const i = r === "e:qvisible";
    (t.charAt(2) !== "e" || i) && kl(o.j, s, t, "");
    i || r === "d:qinit" || r === "d:qidle" ? a($(o.L), r) : Rl(o.k, r);
}

function at(t, n, e) {
    if (t.et) {
        ct(t, n, e, null);
    } else {
        const s = t.O && wl(t.O);
        const o = s && e === Yl(t.O);
        const r = n.key;
        const i = s && t.O.key;
        if (o && r === i) {
            dt(t, e, r);
        } else {
            const s = ht(e, r);
            pt(t, e, r, s, t.T) && ct(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.B || t.O;
    s && function r(t, n, e, s) {
        t.et || ql(t.k, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !Jo.call(o, i) ? i.toLowerCase() : i;
            if (o && Jo.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    Sl(n, l, null);
                    Sl(n, i, e);
                }
                At(c, e) || Zo(t, n, i, c, s);
            } else {
                c != null && Zo(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                Jo.call(e, r) || r.charAt(0) === ":" || xi(r) || Zo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Zo = (t, n, e, s, o) => {
    if (xi(e)) {
        ft(e, s, n.node, n, t);
        return;
    }
    if (e === Qr || e === Hr) {
        Sl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (it(s, t, o)) {
            return;
        }
    }
    const i = n[_i]?.get(e);
    if (Mu(s)) {
        const o = s instanceof Xs ? s.lt() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && qn(t.k, i);
        const r = n;
        s = st(t.k, r, e, o, t.rt.ot);
    } else {
        i && qn(t.k, i);
    }
    if ($i(s)) {
        const o = n;
        const i = s.then(n => {
            F(t.j, o, e, n, t.X, r);
        });
        t.U.push(i);
        return;
    }
    F(t.j, n, e, s, t.X, r);
};

function ht(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function dt(t, n, e) {
    const s = ht(n, e);
    if (s && t.Y?.has(s)) {
        t.Y.delete(s);
        return !0;
    }
    return !1;
}

function pt(t, n, e, s, o, r) {
    t.B = function i(t, n, e) {
        let s = null;
        if (t.H === null) {
            const o = t.O;
            if (o) {
                const s = wl(o) ? Yl(o) : null;
                const r = bt(o) || _t(o, t.k.q);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.H = new Map;
            t.J = [];
            const r = O(t);
            let i = t.O;
            for (;i && i !== r; ) {
                const o = wl(i) ? Yl(i) : null;
                const r = bt(i) || _t(i, t.k.q);
                s === null && r == e && o == n ? s = i : r === null ? t.J.push(o, i) : t.H.set(ht(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.J.length; e += 2) {
                if (t.J[e] === n) {
                    s = t.J[e + 1];
                    t.J.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ht(n, e);
            const r = t.H.get(o);
            if (r) {
                s = r;
                t.H.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.O) {
                    const n = wl(t.O) ? Yl(t.O) : null;
                    const e = bt(t.O) || _t(t.O, t.k.q);
                    if (e != null) {
                        const s = ht(n, e);
                        t.Y ||= new Map;
                        t.Y.set(s, t.O);
                        t.H?.delete(s);
                    }
                }
                return;
            }
            const e = O(t);
            let s = t.O;
            for (;s && s !== n && s !== e; ) {
                const n = wl(s) ? Yl(s) : null;
                const e = bt(s) || _t(s, t.k.q);
                if (e != null) {
                    const o = ht(n, e);
                    t.Y ||= new Map;
                    t.Y.set(o, s);
                    t.H?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.B) {
        s || Ul(t.j, o, t.B, j(t));
        t.O = t.B;
        t.B = null;
        return !1;
    }
    if (s != null) {
        const n = t.Y?.get(s) || null;
        if (n) {
            t.Y.delete(s);
            if (r && t.O) {
                const n = bt(t.O) || _t(t.O, t.k.q);
                if (n != null) {
                    const e = wl(t.O) ? Yl(t.O) : null;
                    const s = ht(e, n);
                    if (s != null) {
                        t.Y ||= new Map;
                        t.Y.set(s, t.O);
                    }
                }
            }
            n !== t.O && Ul(t.j, o, n, j(t));
            t.O = n;
            t.B = null;
            return !1;
        }
    }
    return !0;
}

function $t(t, n, e) {
    const s = n === "F";
    const o = bt(t.O);
    const r = t.O && _l(t.O);
    const i = r && o === e && (!s || !!e);
    if (i) {
        dt(t, null, o);
        return;
    }
    if (e === null || t.et) {
        Xl(t.j, t.T, t.B = $l(), J(t));
        t.B.key = e;
        return;
    }
    if (pt(t, null, e, ht(null, e), t.T, !0)) {
        Xl(t.j, t.T, t.B = $l(), J(t));
        t.B.key = e;
    }
}

function yt(t, n) {
    const e = n[Wa];
    let s = t.B || t.O;
    const o = t.Z;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ut;
        const l = _t(s, t.k.q);
        const u = o.key || c;
        const f = bt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                dt(t, null, u);
            } else {
                wt(t, s, i, n);
                s = t.B;
                r = !0;
            }
        } else {
            if (pt(t, null, u, u, t.T)) {
                wt(t, s, i, n);
                r = !0;
            }
            s = t.B || t.O;
        }
        if (s) {
            const e = El(s, Vr, t.k.q);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = Et(n[Ki], e[Ki], e[es], s, !1);
                        o ||= t;
                        const r = Et(n[ts], e[ts], e[es], s, !0);
                        o ||= r;
                        e[ns] = n[ns];
                    } else if (n) {
                        Sl(t, Vr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.k);
                if (c && o.key == null) {
                    wt(t, s, i, n);
                    s = t.B;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                Sl(s, ar, i);
                s.flags &= -33;
                vn(t.k, s, 4, t.L);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new zs(gt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            fi(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Us(n) && fs(n, $r) || "") + "";
                const i = ci(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            B(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = bt(s);
        const i = e === r;
        const c = _t(s, t.k.q);
        const l = c == null;
        if (s && !l || !s) {
            vt(t);
            s = t.B;
        } else if (i) {
            dt(t, null, e);
        } else {
            pt(t, null, e, e, t.T) && vt(t);
            s = t.B || t.O;
        }
        if (s) {
            let e = s;
            for (;e && (!_l(e) || El(e, ar, null) === null); ) {
                e = e.parent || Ru(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[Gi] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            vn(t.k, s, 8, t.L);
        }
    }
}

function wt(t, n, e, s) {
    n && Pn(t.k, n);
    Xl(t.j, t.T, t.B = $l(), J(t));
    const o = t.Z;
    Sl(t.B, ar, e);
    Sl(t.B, Vr, s);
    t.B.key = o.key;
}

function vt(t) {
    Xl(t.j, t.T, t.B = $l(), J(t));
    const n = t.Z;
    Sl(t.B, Vr, n.props);
    n.key && (t.B.key = n.key);
}

function mt(t, n) {
    if (t.O !== null) {
        const e = Su(t.O);
        if (e === 3) {
            if (n !== Gl(t.O)) {
                Zl(t.j, t.O, n);
                return;
            }
            return;
        }
    }
    Fl(t.j, t.T, t.B = pl(document.createTextNode(n), n), j(t));
}

function bt(t) {
    if (t == null || bl(t)) {
        return null;
    }
    return t.key;
}

function _t(t, n) {
    if (t == null || bl(t)) {
        return null;
    }
    const e = El(t, ar, n);
    return e ? e.ut : El(t, hr, null);
}

function gt() {}

function Et(t, n, e, s, o = !0) {
    if (St(t) && St(n)) {
        return !1;
    }
    e.k = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Rr) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (n && i !== c && At(i, c)) {
                t[s] = c;
                continue;
            }
            if (!n || !At(i, c) && !Tt(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && It(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = cs(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Rr) {
                continue;
            }
            if ((!t || !Jo.call(t, s)) && o) {
                delete n[s];
                const t = cs(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function St(t) {
    if (!t) {
        return !0;
    }
    return Ws(t);
}

function kt(t, n, e, s = null) {
    let o = e;
    const r = s && $n(s) ? $(s) : null;
    if (bl(e)) {
        qt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && $n(o) && u(t, r, o);
        const c = o.flags;
        if (c & 3) {
            Pn(t, o);
            qt(o);
            const r = c & 2 && El(o, ar, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Ur);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Ke(r)) {
                            const n = Tu(r);
                            if (n) {
                                Pn(t, r);
                                if (r.h & 1) {
                                    r.h |= 16;
                                    vn(t, o, 128, s);
                                    continue;
                                }
                                Ho(r);
                            } else if (r instanceof Es || r instanceof Xs) {
                                if (r.h & 4) {
                                    continue;
                                }
                                r instanceof Es ? r.$dispose() : Pn(t, r);
                            }
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Ml(t.rootVNode, e) : e;
                                let c = Kl(o);
                                for (;c; ) {
                                    kt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Pt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = gl(o);
            if (i) {
                if (o === e) {
                    const n = Kl(o);
                    if (n) {
                        gn(n);
                        return;
                    }
                    Rt(t, o);
                }
            } else {
                const t = Kl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && qt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function Rt(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, $r);
    e != null && t.getHostProp(n.slotParent, e) === n && Sl(n.slotParent, e, null);
}

function Pt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Yl(s) === Cr) {
            Rt(t, e);
            Hl(n, s, e, !0);
        }
    }
}

function qt(t) {
    t.flags |= 32;
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Xs && n instanceof Xs && xt(n, t);
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    if (Mu(t) && Mu(n)) {
        const e = t instanceof Xs ? t.lt() : t;
        const s = n instanceof Xs ? n.lt() : n;
        return sa(() => e.value === s.value);
    }
    return !1;
}

function It(t, n) {
    if (t === n) {
        return !0;
    }
    return Io(t) === Io(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return Ao(t) === Ao(n);
}

function xt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ct === t.ct && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ft, t.ft);
}

function Nt(t, n) {
    if (!(n instanceof Xs)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Xs && xt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Ko = (t, n, e, s, o) => {
    const r = Fe(t.an, n, t);
    if (e) {
        r.dn = w(e, ":");
        r.k = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, ar));
    if (fr(s)) {
        o = o || t.getHostProp(n, Vr) || os;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (za(s)) {
        const t = s;
        i = () => Le(r, t, [ o || os, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => Le(r, t, [ o || os ]);
    }
    const l = ze;
    const u = (e = 0) => yi(() => {
        if (!c) {
            t.setHostProp(n, Br, null);
            t.setHostProp(n, Gr, null);
        }
        e > 0 && yl(n) && Pn(t, n);
        return wi(i(o), t => wi(r.pn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < pi) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Yr);
        if (o) {
            return function r(t, n, e) {
                const s = Lt(n);
                let o = n;
                return wi(s, n => {
                    const s = !n;
                    let r = null;
                    for (const i in e) {
                        if (Object.prototype.hasOwnProperty.call(e, i)) {
                            let c = n;
                            let l = i;
                            if (s) {
                                if (i !== Dr && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    r = Xt();
                                    const n = ze;
                                    n && t.ht(r) || (o = Ft(o, r));
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === Dr && (l = "q-d:qinit");
                                Ot(c, l, e[i]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if ($i(t) && e < pi) {
            return t.then(() => u(++e));
        }
        if (e >= pi) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Ot(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Oi(n);
    c && jt(t, f, "capture");
    l && jt(t, f, "preventdefault");
    u && jt(t, f, "stoppropagation");
}

function jt(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === os && (t.varProps = {});
    t.varProps[s] = !0;
}

function Lt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Us(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (tr(t)) {
            n.push(...t);
        } else {
            if ($i(t)) {
                return wi(t, t => Lt(t));
            }
            if (Mu(t)) {
                return Lt(t.untrackedValue);
            }
        }
    }
    return null;
}

function Ft(t, n) {
    return tr(t) ? [ ...t, n ] : [ t, n ];
}

function Xt() {
    return new zs("script", null, {
        hidden: ""
    }, null, 0, ":useOn");
}

function Dt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Wt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Dt(t[c], c, r, s);
    }
    return i;
}

function zt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Vt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Kl(e);
    const f = X(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Go(c, n, Wt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Jl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Go(c, n, Wt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Jl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            Hl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return Go(c, n, Wt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const _ = d - h + 1;
    const m = new Map;
    for (let t = h; t <= d; t++) {
        m.set(a[t], t - h);
    }
    const b = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < b.length; t++) {
        const s = b[t];
        const o = s.key;
        if (m.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            Hl(n, e, s, !0);
        }
    }
    const S = new Int32Array(_);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < _; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(_);
    const q = function I(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < q.length; t++) {
        P[R[q[t]]] = 1;
    }
    let T = d;
    let A = w;
    const M = () => {
        for (;T >= h; ) {
            const t = T - h;
            if (P[t] === 1) {
                A = g[S[t]];
                T--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Ul(n, e, t, A);
                A = t;
                T--;
                continue;
            }
            let l = T;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = T - l + 1;
            const d = Go(c, n, Wt(o, a, null, i, l, T), e, A, A, s, null, !0, f);
            return wi(d, () => {
                const t = zt(e, A, u);
                A = t;
                T = l - 1;
                return M();
            });
        }
    };
    return M();
}

function Ut(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Ur);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Au) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = qu(s, n, t);
                $i(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Bt(t, n) {
    const e = t.props ||= {};
    e[Hi] = n;
}

function Qt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Ji] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Ji] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = jl(n, document, r, e);
    const u = wl(r) && i || r;
    const f = u === r ? null : c;
    Fl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Ht(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Hi];
    }(t);
    if (!r) {
        return;
    }
    Bt(t, null);
    Mu(r) && (r = r.value);
    return Yo(n, e, r, o, s, null);
}

function Jt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, ar);
    if (r && !r.resolved) {
        return r.resolve().catch(n => {
            t.dirty &= -5;
            throw n;
        });
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Vr) || null;
    return Gt(n, o, o, r, i, e, s);
}

function Yt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[Gi] || null;
        e && delete n[Gi];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Gt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Gt(n, e, s, o, r, i, c) {
    const l = yi(() => Ko(n, e, s, o, r), s => {
        const o = n.getHostProp(e, Sr);
        return t(() => Yo(n, i, s, e, c, Ro(o)));
    }, t => {
        n.handleError(t, e);
    });
    if ($i(l)) {
        return l;
    }
    return;
}

function Zt(t, n, e, s, o, r = null) {
    n.push(zo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Kt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Qi] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Mu(e) && (e = e.value);
        const r = s.isConst;
        Zt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Qi];
    })(t);
}

function tn(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Ur);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Au && n.h & 16) {
            n.h &= -17;
            const t = n;
            Ho(t);
        }
    }
}

function nn(n, e) {
    n.dirty &= -33;
    const s = e.getHostProp(n, Yi);
    if (!s) {
        return;
    }
    const o = s.dt;
    const r = Xe();
    r.k = e;
    return wi(t(() => je.call(s, r, s.$)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return ju(e, s, o);
        }
    });
}

function en(t, n, e, s) {
    t.dirty &= -257;
    if (!__EXPERIMENTAL__.each) {
        return;
    }
    const o = t;
    const r = n.getHostProp(o, Vr) || null;
    if (!r) {
        return;
    }
    let i = as(r, "items");
    Mu(i) && (i = sa(i));
    const c = as(r, "key$");
    const l = as(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Vt(n, e, o, s, i, u, f);
    }
    return wi(c.resolve(), t => wi(l.resolve(), r => Vt(n, e, o, s, i, t, r)));
}

let tl = null;

const nl = (t, n, e) => {
    tl || (tl = t.insertBefore);
    tl.call(t, n, e);
};

function rn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                nl(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                nl(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let i = 0; i < t.length; i++) {
        const c = t[i];
        if (c instanceof jo) {
            if (n === c.parent && e === c.beforeTarget) {
                s || (s = []);
                s.push(c.target);
                o.add(c.target);
                continue;
            }
            if (!s) {
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (n === c.parent) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (o.has(c.target) || e && c.target === e || n && c.target === n) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            nl(c.parent, c.target, c.beforeTarget);
            continue;
        }
        if (c instanceof No) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            c.target.remove();
            continue;
        }
        if (c instanceof Co) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            const t = c.target;
            t.textContent = "";
            continue;
        }
        if (c instanceof Oo) {
            c.target.nodeValue = c.text;
        } else if (c instanceof Lo) {
            const t = c.target;
            const e = c.attrName;
            const s = c.attrValue;
            const o = s != null ? P(e, s, c.scopedStyleIdPrefix) : null;
            const i = o == null || o === !1;
            if (el(t, e)) {
                t[e] = rl(o);
            } else if (e === ei) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(xr, "html");
            } else {
                i ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : g(t, e, o, c.isSvg);
            }
        }
    }
    r();
}

const el = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const rl = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const il = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.Xn = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const sl = (t => () => queueMicrotask(t))(ln);

const ll = il(ln);

const ul = /*#__PURE__*/ lr("cursorTick", () => ({
    isScheduled: !1
}));

function sn() {
    if (!ul.isScheduled) {
        ul.isScheduled = !0;
        sl();
    }
}

function on() {
    if (!ul.isScheduled) {
        ul.isScheduled = !0;
        ll();
    }
}

function ln() {
    ul.isScheduled = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = s(); ) {
        if (un(e, n)) {
            on();
            return;
        }
    }
}

function un(t, n) {
    const e = ze;
    const s = $(t);
    const r = s.promise;
    if (r) {
        return;
    }
    const i = s.container;
    if (!t.dirty) {
        cn(i, t, s, e);
        return;
    }
    const c = s.journal ||= [];
    let u = null;
    for (;u = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(u.dirty & 1023)) {
            __EXPERIMENTAL__.pendingBoundary && T(u);
            d(i, s, hn(u, t, i));
            continue;
        }
        if (u.flags & 32) {
            if (u.dirty & 128) {
                tn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            }
            u.dirty &= -1024;
            d(i, s, hn(u, t, i));
            continue;
        }
        let e;
        try {
            if (u.dirty & 1) {
                e = Ut(u, i, s);
            } else if (u.dirty & 2) {
                e = Ht(u, i, c, t);
            } else if (u.dirty & 4) {
                e = Jt(u, i, c, t);
            } else if (u.dirty & 8) {
                e = Yt(u, i, c, t);
            } else if (u.dirty & 256) {
                e = en(u, i, c, t);
            } else if (u.dirty & 16) {
                Kt(u, c);
            } else if (u.dirty & 32) {
                e = nn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            } else {
                u.dirty & 512 && Qt(u, c);
            }
        } catch (t) {
            i.handleError(t, u);
        }
        if (e && $i(e)) {
            q(s, u);
            const n = e;
            s.promise = n;
            o(t, i);
            const r = u;
            n.catch(t => {
                s.promise === n && i.handleError(t, r);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                l(t, i);
                sn();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    cn(i, t, s, e);
}

function cn(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        c(n, t);
        s || function o(t, n) {
            const e = $(t);
            const s = e.journal;
            if (s && s.length > 0) {
                rn(s);
                e.journal = null;
            }
            const o = h(e);
            if (o) {
                for (let t = 0; t < o.length; t++) {
                    Rl(n, o[t]);
                }
            }
            (function r(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    qu(s, t, s.$t);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.pendingBoundary) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function i(t) {
            __EXPERIMENTAL__.pendingBoundary && t.props && Kr in t.props && Sl(t, Kr, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                fn(t);
            });
            return;
        }
        fn(t);
    }
}

function fn(t) {
    t.yt();
}

function an(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = hn(o[0], s, t);
    d(t, n, i);
    return i;
}

function hn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && dn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.pendingBoundary && T(s);
    return hn(s, n, e);
}

function dn(t, n) {
    if (!A(n)) {
        return !1;
    }
    $n(n) || pn(t, n, 0);
    return !0;
}

function pn(t, n, e) {
    if ($n(n)) {
        sn();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Bi.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    i(t, r);
    sn();
    return r;
}

function $n(t) {
    return (t.flags & 256) !== 0;
}

function yn(t, n) {
    if (!(n.flags & 1)) {
        let e;
        n.dirty & 16 && function s(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Qi);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Mu(e) && (e = e.value);
                const r = P(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && (e = nn(n, t));
        n.dirty &= -1024;
        return e;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Ur);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Au) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = qu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        $i(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            if (!__EXPERIMENTAL__.each) {
                return;
            }
            const e = n;
            const s = t.getHostProp(e, Vr) || null;
            if (!s) {
                return;
            }
            let o = as(s, "items");
            Mu(o) && (o = sa(o));
            const r = await as(s, "key$").resolve();
            const i = await as(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const cl = [];

function wn(t) {
    for (let n = 0; n < cl.length; n++) {
        const e = cl[n];
        const s = cl[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function vn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return ze;
    }()) {
        const e = yn(t, n);
        $i(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return e;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            cl.push(n);
            let s = A(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const r = $n(o);
                __EXPERIMENTAL__.pendingBoundary && (s ||= A(o) || (t ? I(o) : null));
                if (o === e || t) {
                    M(n, s);
                    wn(o);
                    if (r) {
                        const t = $(o);
                        t.position !== o && (t.position = n);
                    }
                    cl.length = 0;
                    return;
                }
                if (r) {
                    const t = $(o);
                    t.position !== o && (t.position = n);
                }
                cl.push(o);
                o = o.slotParent || o.parent;
            }
            cl.length = 0;
            ((t, ...n) => {
                const e = Ge(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, A(n) || I(c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if ($n(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = $(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        $n(n) ? M(n, A(n)) : function l(t) {
            cl.push(t);
            let n = A(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = $n(e);
                __EXPERIMENTAL__.pendingBoundary && (n ||= A(e) || (s ? I(e) : null));
                if (s) {
                    M(t, n);
                    wn(e);
                    cl.length = 0;
                    return !0;
                }
                cl.push(e);
                e = e.slotParent || e.parent;
            }
            M(t, n);
            cl.length = 0;
            return !1;
        }(n) || pn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const fl = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const al = t => {
    let n = null;
    return e => {
        n || (n = fl(e, t));
        return n.call(e);
    };
};

const hl = (t, n, e = null) => {
    const s = new Wi(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const dl = t => {
    const n = new Wi(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const pl = (t, n) => {
    const e = new zi(-4084, null, null, null, null, t, n);
    return e;
};

const $l = () => {
    const t = new Di(null, -4094, null, null, null, null, null, null);
    return t;
};

const yl = t => t instanceof Xi;

const wl = t => (t.flags & 1) === 1;

const vl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const ml = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const bl = t => (t.flags & 4) === 4;

const _l = t => (t.flags & 2) === 2;

const gl = t => {
    const n = t.flags;
    return (n & 2) === 2 && El(t, $r, null) !== null;
};

const Wd = t => t;

const El = (t, n, e) => {
    if (wl(t) || _l(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const Sl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const kl = (t, n, e, s, o = null) => {
    if (wl(n)) {
        Sl(n, e, s);
        mn(t, zo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Rl = (t, n) => {
    const e = window;
    e && (e._qwikEv ||= []).push(n);
};

const Pl = t => {
    if (t.key) {
        return;
    }
    const n = iu(t.node, ni);
    n && (t.key = n);
};

const ql = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (xi(c)) {
                bn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== ni && c) {
                if (c.startsWith(xr)) {
                    const t = i.value;
                    t === "html" ? Sl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && Sl(e, "value", s.value);
                } else {
                    const t = i.value;
                    Sl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        El(e, Qr, null) === null && El(e, Hr, null) === null || (n.flags |= 64);
    }
};

const Al = t => {
    if (t.Et === "_run") {
        const n = t.getCaptured()?.[0];
        if (fr(n)) {
            return n;
        }
    }
    return t;
};

function bn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Al(Xn(i[t], e));
        c.push(N.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function _n(t, n, e) {
    let s = Kl(n);
    for (;s; ) {
        if (bl(s)) {
            Il(t, s);
            e(s, n);
        } else {
            wl(s) ? e(s, n) : _n(t, s, e);
        }
        s = s.nextSibling;
    }
}

function gn(t) {
    let n = t;
    if (bl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Kl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Tl = (t, n, e) => {
    let s = t;
    for (;e && s && _l(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !_l(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !_l(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (bl(t) && e && wl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && bu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Il = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Bl(n, !0);
        const o = e.node;
        const r = pu(s);
        let i = Tl(n, !1, !0);
        const c = Tl(n, !0, !0);
        const l = o || (c && wl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && bl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, Wo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Tl(i, !1, !0);
        }
        i = n;
        for (;i && bl(i); ) {
            const n = Tl(i, !0, !0);
            const e = !n || !bl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Do(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, Wo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Ml = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const e = t.vNode;
        if (e) {
            return e;
        }
    }
    if (yl(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = Cl(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Ol(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = xl(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const xl = (t, n) => {
    let e = Kl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Nl = [];

const Cl = (t, n) => {
    let e = Kl(t);
    for (;e && (!(e instanceof Wi) || e.node !== n); ) {
        if (_l(e)) {
            const t = e.nextSibling;
            const n = Kl(e);
            if (n) {
                t && Nl.push(t);
                e = n;
            } else {
                e = t || (Nl.length ? Nl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Nl.pop();
        }
    }
    for (;Nl.length; ) {
        Nl.pop();
    }
    return e;
};

const Ol = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const jl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = hl(o, "errored-host");
    if (vl(e)) {
        Ul(t, r, e, null);
    } else {
        const n = [];
        _n(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Ul(t, r, n[e], null);
        }
    }
    return r;
};

const Ll = rn;

const Fl = (t, n, e, s) => {
    const o = wl(n);
    o && tu(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    zl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Bl(n, !1);
    l && !c && mn(t, Wo(i, l, Dl(t, n, s)?.node ?? null));
    Wl(n, e, s);
    c && (e.flags |= 32);
};

const Xl = (t, s, o, r) => {
    const i = wl(s);
    i && tu(s);
    const c = o.parent;
    if (o === r) {
        if (c) {
            return;
        }
        r = null;
    }
    zl(t, c, s, o);
    const l = s.flags & 32;
    const u = !i && s.flags & 2048 ? s.props?.[dr] : null;
    const f = u ? null : i ? s : Ql(s, !1);
    const a = u || f?.node;
    const h = Dl(t, s, r);
    const d = h?.node ?? null;
    const p = gl(o);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Ql(s, !1);
        const c = Dl(t, s, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = e(i, o);
        _n(t, o, s => {
            if (bl(s)) {
                mn(t, Wo(s.node, a, c));
            } else {
                if ((s.flags & 1536) !== u) {
                    const t = function o(t, s, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let o = null;
                            let a = null;
                            if (wl(c)) {
                                o = c.node;
                                const t = Yl(c);
                                const l = c.parent;
                                const h = u == null ? s : l && Ql(l, !0);
                                if (h) {
                                    const t = e(h, Yl(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Kl(c);
                                a = n(o, t, r, !d);
                                o.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (eu(o)) {
                                    const t = Me(o);
                                    if (t) {
                                        const n = Kl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(s, i, l, u);
                    t && (s.node = t);
                }
                mn(t, Wo(s.node, a, c));
            }
        });
    } else {
        a && !l && _n(t, o, n => {
            mn(t, Wo(n.node, a, d));
        });
    }
    Wl(s, o, r);
    l && (o.flags |= 32);
};

const Dl = (t, n, e) => {
    let s = null;
    e == null ? _l(n) && (s = Tl(n, !0, !1)) : s = _l(e) ? Tl(e, !0, !0) : e;
    s && bl(s) && Il(t, s);
    return s;
};

const Wl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const zl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Hl(t, n, s, !1);
};

const Vl = (t, n) => {
    let e = n;
    for (;e && _l(e); ) {
        e = e.lastChild;
    }
    e && bl(e) && (e.flags & 8) === 0 && Il(t, e);
};

const Ul = (t, n, e, s) => {
    vl(e) ? Fl(t, n, e, s) : Xl(t, n, e, s);
};

const Bl = (t, n) => {
    for (;t && !wl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[dr];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Ql = (t, n) => {
    for (;t && !wl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Hl = (t, n, e, s) => {
    bl(e) && Il(t, e);
    if (s) {
        const s = El(n, ei, null) !== null;
        if (s) {
            return;
        }
        vl(e) ? mn(t, Fo(e.node)) : _n(t, e, n => {
            mn(t, Fo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Jl = (t, n, e, s = !0) => {
    const o = Bl(n, !0);
    if (o && s) {
        if (vl(n)) {
            mn(t, Xo(n.node));
        } else {
            const e = Ql(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, Xo(o)) : _n(t, n, n => {
                mn(t, Fo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Yl = t => {
    const n = Wd(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = du(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = hu(t);
            switch (n) {
              case Lr:
                return 512;

              case Fr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Gl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Zl = (t, n, e) => {
    Il(t, n);
    n.text = e;
    mn(t, Do(n.node, e));
};

const Kl = t => {
    if (bl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.pendingBoundary && n === void 0 && wl(t) && function e(t) {
        const n = t.getAttribute(jd);
        if (n === null) {
            return !1;
        }
        const e = au(t);
        return ku(e) && e.localName === "template" && e.getAttribute(mr) === n && uu(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = tu(t));
    return n;
};

const tu = t => {
    const n = Wd(t);
    let e = n.firstChild;
    if (e === void 0) {
        const t = n.node;
        e = n.parent && eu(t) ? n.firstChild = n.lastChild = null : (t => {
            const n = t.node;
            const e = au(n);
            const s = pu(n)?.qVNodeData?.get(n);
            const o = ((t, n, e, s) => {
                Pl(t);
                __EXPERIMENTAL__.pendingBoundary && n._qSegment;
                if (s) {
                    if (s.charCodeAt(0) === Pi && s.charCodeAt(1) === Pi) {
                        const n = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(s);
                        const o = n.elementVNodeData;
                        s = n.virtualVNodeData;
                        const r = $u(t, e, o);
                        if (!s) {
                            return r;
                        }
                    }
                    return function o(t, n, e, s) {
                        let o = 0;
                        let r = null;
                        let i = null;
                        let c = null;
                        const l = n => {
                            n.flags = n.flags & 4095 | o << 12;
                            o++;
                            i && (i.nextSibling = n);
                            n.previousSibling = i;
                            n.parent = t;
                            r || (t.firstChild = r = n);
                            i = n;
                        };
                        let u = 0;
                        let f = null;
                        let a = null;
                        const h = t => {
                            const n = ku(t);
                            return !n || n && Rn(t);
                        };
                        let d = null;
                        yu(n, (p, $, y, w, _, m) => {
                            if (_u(p())) {
                                for (;h(s); ) {
                                    s = uu(s);
                                    if (!s) {
                                        throw rr(27, [ n, p(), _ ]);
                                    }
                                }
                                f = null;
                                c = null;
                                let t = 0;
                                for (;_u(p()); ) {
                                    t *= 10;
                                    t += y() - 48;
                                }
                                for (;t--; ) {
                                    const e = dl(s);
                                    Pl(e);
                                    l(e);
                                    s = uu(s);
                                    for (;ku(s) && Rn(s); ) {
                                        s = uu(s);
                                        if (!s && t > 0) {
                                            throw rr(27, [ n, p(), _ ]);
                                        }
                                    }
                                }
                            } else if (p() === 59) {
                                Sl(t, Sr, $());
                            } else if (p() === 60) {
                                const n = $();
                                if (n.charCodeAt(0) === 95) {
                                    Sl(t, hr, decodeURIComponent(E(n.slice(1))));
                                } else {
                                    (d ||= []).push(t);
                                    Sl(t, ar, n);
                                }
                            } else if (p() === 61) {
                                a || (a = Ie(e));
                                const n = $();
                                a.zn(parseInt(n, 10), t);
                            } else if (p() === 62) {
                                Sl(t, Vr, $());
                            } else if (p() === 64) {
                                t.key = m();
                            } else if (p() === 91) {
                                Sl(t, Ur, $());
                            } else if (p() === 94) {
                                Sl(t, Br, $());
                            } else if (p() === 96) {
                                a || (a = Ie(e));
                                Sn(t, $(), a);
                            } else if (p() === 63) {
                                a || (a = Ie(e));
                                t.slotParent = Ml(a.rootVNode, $());
                            } else if (p() === 93) {
                                Sl(t, kr, $());
                            } else if (p() === 123) {
                                y();
                                l($l());
                                Eu.push(t, r, i, c, o);
                                o = 0;
                                t = i;
                                r = i = null;
                            } else if (p() === Pi) {
                                const n = $();
                                const e = decodeURIComponent(E(n));
                                const s = _ + n.length + 1;
                                const o = w(s + 1) === Pi;
                                let r;
                                if (o) {
                                    y();
                                    r = decodeURI(E($()));
                                    y();
                                } else {
                                    r = E($());
                                }
                                Sl(t, e, r);
                            } else if (p() === 125) {
                                y();
                                t.lastChild = i;
                                o = Eu.pop();
                                c = Eu.pop();
                                i = Eu.pop();
                                r = Eu.pop();
                                t = Eu.pop();
                            } else if (p() === 126) {
                                Sl(t, $r, m());
                            } else {
                                for (;ku(s) && Rn(s); ) {
                                    s = uu(s);
                                }
                                const t = s && su(s) === 3 ? s : null;
                                if (f === null) {
                                    f = t ? t.nodeValue : null;
                                    u = 0;
                                }
                                let n = 0;
                                for (;gu(p()); ) {
                                    n += y() - 97;
                                    n *= 26;
                                }
                                n += y() - 65;
                                const e = f === null ? "" : f.substring(u, u + n);
                                l(c = ((t, n, e) => {
                                    const s = new zi(-4092, null, t, null, null, n, e);
                                    return s;
                                })(c, t, e));
                                u += n;
                            }
                        });
                        if (d) {
                            a || (a = Ie(e));
                            for (let t = 0; t < d.length; t++) {
                                a.ensureProjectionResolved(d[t]);
                            }
                            d = null;
                        }
                        t.lastChild = i;
                        return r;
                    }(t, s, n, e);
                }
                return $u(t, e, void 0);
            })(t, n, e, s);
            return o;
        })(n);
    }
    return e;
};

let nu = null;

const eu = t => {
    nu || (nu = t.hasAttribute);
    return nu.call(t, xr);
};

let ru = null;

const iu = (t, n) => {
    ru || (ru = t.getAttribute);
    return ru.call(t, n);
};

const su = al("nodeType");

const ou = t => {
    const n = su(t);
    return n === 3 || n === 1;
};

let lu = null;

const uu = t => {
    lu || (lu = fl(t, "nextSibling"));
    fu || (fu = fl(t, "firstChild"));
    for (;t; ) {
        t = lu.call(t);
        if (t !== null) {
            const n = su(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Ir)) {
                    return En(t, Ar, lu, fu);
                }
                if (t.nodeValue?.startsWith(Tr)) {
                    return En(t, [ Ar, Mr ], lu, fu);
                }
                if (n?.startsWith(xr)) {
                    for (;t && (t = lu.call(t)) && (su(t) !== 8 || !t.nodeValue?.startsWith(Nr)); ) {}
                }
            }
        }
    }
    return t;
};

function En(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = cu(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const cu = al("parentNode");

let fu = null;

const au = t => {
    fu || (fu = fl(t, "firstChild"));
    t = t && fu.call(t);
    if (t && su(t) === 8) {
        lu || (lu = fl(t, "nextSibling"));
        if (t.nodeValue?.startsWith(Ir)) {
            return En(t, Ar, lu, fu);
        }
    }
    for (;t && !ou(t); ) {
        t = uu(t);
    }
    return t;
};

const hu = al("namespaceURI");

const du = al("nodeName");

const pu = al("ownerDocument");

const $u = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;ku(i) && Rn(i); ) {
            i = uu(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = su(i);
        let e = null;
        if (n === 3) {
            e = pl(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = dl(i);
            Pl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = uu(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        yu(e, (e, s) => {
            if (e() === 61) {
                n || (n = Ie(t.node));
                const e = s();
                n.zn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Ie(t.node));
                Sn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function Sn(t, n, e) {
    if (t[_i]) {
        const s = t[_i];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.q(n));
    } else {
        Object.defineProperty(t, _i, {
            get() {
                const s = e.q(n);
                t[_i] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, _i, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const yu = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    const u = () => {
        if (r(e + 1) !== Pi) {
            return l();
        }
        c();
        const t = decodeURIComponent(E(l()));
        c();
        return t;
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e, u);
    }
};

const wu = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        ql(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(ni) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const vu = (t, n) => {
    let e = mu(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = mu(e);
    }
    return !1;
};

const mu = t => t.parent || t.slotParent;

const bu = t => {
    if (t === null || _l(t)) {
        return null;
    }
    return t.node;
};

function kn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (wl(e)) {
                        const t = xe(e.node);
                        if (!t) {
                            return null;
                        }
                        return Me(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (bl(i)) {
            c.push(xn(Gl(i)));
        } else if (_l(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = wu(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Ei && e !== "__scopedStyleIdPrefix__") {
                        const t = El(i, e, null);
                        s.push(" " + e + "=" + xn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (Si[El(i, Ei, null) || "V"] || Si.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Kl(i);
            u && c.push("  " + kn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (wl(i)) {
            const s = Yl(i);
            const l = [];
            $n(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? wu(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = El(i, n, null);
                l.push(" " + n + "=" + xn(e));
            }
            const f = bu(i);
            if (f) {
                const t = pu(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + xn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + xn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (ml(i) || e) {
                const e = Kl(i);
                e && c.push("  " + kn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const _u = t => 48 <= t && t <= 57;

const gu = t => 97 <= t && t <= 122;

function Rn(t) {
    return !t.hasAttribute(ni) || t.nodeName === "STYLE" && (t.hasAttribute(Sr) || t.hasAttribute(_r));
}

const Eu = [];

const Su = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw rr(26, [ n ]);
};

const ku = t => t && typeof t == "object" && su(t) === 1;

const Ru = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!_l(t) || El(t, ar, null) === null); ) {
            const e = t.slotParent;
            const s = _l(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function Pn(t, n) {
    yl(n) && wl(n) && tu(n);
    const e = n[_i];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        qn(t, n);
    }
    e.clear();
}

function qn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof _s) {
            An(t, s, n);
            s instanceof Es && Tn(s, n);
        } else if (ps(s)) {
            const t = s[es];
            In(t, n);
        } else if (t.wt.has(s)) {
            const e = t.wt.get(s);
            const o = zu(e);
            In(o, n);
        }
    }
    e.clear();
}

function An(t, n, e) {
    const s = n.dt;
    s && s.has(e) && s.delete(e);
    if (n instanceof Xs && !s?.size) {
        n.R = void 0;
        Pn(t, n);
    }
}

function Tn(t, n) {
    const e = t.vt;
    e && e.has(n) && e.delete(n);
    const s = t.bt;
    s && s.has(n) && s.delete(n);
    t._t();
}

function In(t, n) {
    const e = t?.dt;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Pu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Vo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Au(6 | i, r, o.R, t, null);
    s(c);
    const l = o.k;
    const {pn: u} = o;
    const f = wi(u, () => qu(c, l, o.R));
    $i(f) && (o.pn = f);
};

const qu = (t, n, e) => {
    const s = t.Vn;
    if (s) {
        return s;
    }
    const o = t => {
        Df(t, "hook");
        n.handleError(t, e, "hook");
    };
    let r = null;
    const i = wi(((t, n) => {
        const e = t.Un;
        if (e) {
            return e;
        }
        const s = t.Xn;
        if (!s) {
            return;
        }
        t.Xn = null;
        try {
            const e = s();
            if ($i(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Un === s && (t.Un = void 0);
                });
                t.Un = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        t.h = t.h & -5 | 64;
        const s = Xe(n.an, e, "qTask");
        s.k = n;
        const i = t.gt.getFn(s, () => Pn(n, t));
        const c = bs(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.Xn = () => {
                            t.Xn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    $i(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return yi(() => i(u), l, s => {
            if ($i(s)) {
                return s.then(() => {
                    t.Vn === r && (t.Vn = null);
                    return qu(t, n, e);
                }, o);
            }
            o(s);
        });
    });
    if ($i(i)) {
        r = i.finally(() => {
            if (t.Vn === r) {
                t.Vn = null;
                t.h & 4 && vn(n, e, 1);
            }
        });
        t.Vn = r;
        return r;
    }
    return i;
};

class Au extends gi {
    h;
    Dt;
    $t;
    gt;
    Xn;
    Un;
    Vn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Dt = n;
        this.$t = e;
        this.gt = s;
        this.Xn = o;
    }
}

Fi(Au, 32);

const Tu = t => Li(t, 32);

function Mn(t, n) {
    const e = Ie(n);
    return Gf(e, () => {
        typeof this === "string" && Sa(ka(e, this));
        const t = ga._[0];
        if (!t.$t) {
            return;
        }
        if (t.h & 68) {
            return;
        }
        t.h |= 4;
        vn(e, t.$t, 1);
    });
}

const Iu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Mu = t => Li(t, 1);

const xu = (t, n) => {
    t.add(n);
};

const Nu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Cu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Tu(e) ? o = e.gt : e instanceof Es ? o = e.zt : s === ":" && (o = n.getHostProp(e, ar));
        o && n.serializationCtx.Xt.add(o);
    }
};

const Ou = (t, n) => {
    if (t && (!n || t === n || Dd(t))) {
        return t;
    }
    return n;
};

const ju = (t, n, e) => {
    const s = Ve;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Tu(o)) {
                o.h |= 4;
                vn(t, o.$t, 1);
            } else if (o instanceof _s) {
                o.invalidate();
            } else if (r === ":") {
                vn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Bt(o, n);
                    vn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Ds) {
                    const e = i.data;
                    const c = {
                        isConst: e.st,
                        scopedStyleIdPrefix: e.X,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Qi];
                            if (!o) {
                                o = new Map;
                                s[Qi] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Qi);
                        if (!n) {
                            n = new Map;
                            t.setProp(Qi, n);
                        }
                        n.set(r, c);
                    }
                    vn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Lu = t => Ke(t) && typeof t[kf] === "function";

const Fu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Xu = t => {
    t.h |= 4;
};

const Du = [];

function xn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Tu(t)) {
            return `Task(${xn(t.gt)})`;
        }
        if (fr(t)) {
            return `Qrl(${t.Et})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Du.includes(t)) {
                return "*";
            }
            Du.length;
            try {
                Du.push(t);
                if (Array.isArray(t)) {
                    return yl(t) ? "(" + (El(t, Ei, null) || "vnode") + ")" : t.map(xn);
                }
                if (Mu(t)) {
                    return t instanceof Xs ? "WrappedSignal" : t instanceof Es ? "ComputedSignal" : "Signal";
                }
                if (Hu(t)) {
                    return "Store";
                }
                if (Us(t)) {
                    return Wu(t);
                }
                if (yl(t)) {
                    return "(" + (El(t, Ei, null) || "vnode") + ")";
                }
            } finally {
                Du.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Wu = t => {
    if (Us(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Wa];
            if (n) {
                const [t] = n;
                return "Component(" + t.Et + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + xn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Wu(e);
                    }
                } else {
                    n += Wu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const zu = t => t[vs];

const Vu = t => {
    try {
        return t?.[ws] || null;
    } catch {
        return null;
    }
};

const Uu = (t, n) => {
    const e = zu(t);
    e && e.force(n);
};

const Bu = (t, n) => {
    const e = zu(t);
    if (e) {
        return (e.dt?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Qu = t => Vu(t) || t;

const Hu = t => ws in t;

function Nn(t, n, e) {
    return new Proxy(n, new Yu(e, t || null));
}

const Ju = (t, n, e) => {
    if (Ze(t) && e) {
        let s = e.wt.get(t);
        if (!s) {
            s = Nn(e, t, n);
            e.wt.set(t, s);
        }
        return s;
    }
    return t;
};

class Yu {
    h;
    k;
    dt=void 0;
    constructor(t, n) {
        this.h = t;
        this.k = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Vu(this);
        ju(this.k, this, jn(n, t, this.dt));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === ws) {
                return t;
            }
            if (n === vs) {
                return this;
            }
            return t[n];
        }
        const e = na();
        const s = t[n];
        if (e) {
            if (this.k === null) {
                if (!e.k) {
                    return s;
                }
                this.k = e.k;
            }
            const o = e.dn;
            o && Cn(t, Array.isArray(t) ? ms : n, this, o, e.k);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        let r = !1;
        if (o & 1 && Ke(s)) {
            try {
                r = !Object.isFrozen(s) && !Hu(s) && !Object.isFrozen(t);
            } catch {}
        }
        if (r) {
            return Ju(s, this.h, this.k);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Qu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && On(n, s, t, this);
        } else {
            On(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || ju(this.k, this, jn(t, n, this.dt));
        return !0;
    }
    has(t, n) {
        if (n === ws) {
            return !0;
        }
        if (typeof n === "string") {
            const e = na();
            if (e) {
                const s = e.dn;
                s && Cn(t, Array.isArray(t) ? ms : n, this, s, e.k);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = na();
        const e = n?.dn;
        e && Cn(t, ms, this, e, n.k);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

Fi(Yu, 8192);

function Cn(t, n, e, s, o) {
    const r = e.dt ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = ze;
    const l = __EXPERIMENTAL__.pendingBoundary && e instanceof Yu && c;
    xu(i, s);
    Nu(s, t);
    if (c) {
        const i = Ou(o, e.k);
        l && i?.vn?.(t, s, n, r);
        Cu(s, i);
    }
}

function On(t, n, e, s) {
    e[t] = n;
    const o = jn(e, t, s.dt);
    o && ju(s.k, s, o);
}

function jn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(ms);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Gu = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Zu = '"';

const Ku = "[";

const tc = "]";

const nc = ",";

const ec = /*#__PURE__*/ or("undefined");

const rc = [ void 0, null, !0, !1, "", ss, os, $s, ms, is, ho, fo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const ic = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const sc = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function Ln(t, n, e) {
    let s = n.Et;
    let o = n.St;
    const r = ui();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => fr(t) && t.Et == cr)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.kt(null, 0, e) + "";
    } else {
        o || (o = t.Rt(n.ut));
        if (!o) {
            throw rr(14, [ n.Et ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.Pt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Fn(t, n, e, s) {
    return Aa(t, n, null, null, e, s);
}

function Xn(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return Fn(o, r, i, n);
}

class oc {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

Fi(oc, 1048576);

class lc {
    Bn;
    Qn=0;
    At=[];
    Hn=0;
    Jn=new Set;
    Yn=new Map;
    Gn;
    Zn=new Map;
    Kn=0;
    te=new WeakSet;
    Gt;
    ne=typeof Temporal !== "undefined";
    constructor(t) {
        this.Bn = t;
        this.Gt = t.Gt;
    }
    async serialize() {
        const t = this.Kn;
        this.Kn = 0;
        this.te = new WeakSet;
        try {
            await this.outputRoots();
        } finally {
            this.Kn = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.Kn;
        this.Kn = s;
        this.te = new WeakSet;
        this.Gt.write(Ku);
        this.Bn.ee = 0;
        try {
            this.Gt.write(t + "");
            this.Gt.write(nc);
            this.Gt.write(Ku);
            await this.outputSelectedRoots(n);
            this.Gt.write(tc);
            const s = this.getForwardRefsPayload();
            this.Bn.ee = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Gt.write(nc);
                s ? this.outputForwardRefsArray(s) : this.Gt.write("0");
            }
            if (e !== void 0) {
                this.Gt.write(nc);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Gt.write(Zu);
                    this.writeRootRefPath(e);
                    this.Gt.write(Zu);
                }
            }
        } finally {
            this.Kn = o;
        }
        this.Gt.write(tc);
    }
    re(t) {
        this.Gt = t;
    }
    outputArray(t, n, e) {
        this.Gt.write(Ku);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Gt.write(nc) : s = !0;
            e(t[n], n);
        }
        this.Gt.write(tc);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Zu + t + Zu;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Gt.write(n.slice(s, e));
            this.Gt.write("<\\/");
            s = e + 2;
        }
        this.Gt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Gt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Gt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Gt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Gt.write(Zu);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Gt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Gt.write(Zu);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Gt.write(t + nc);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Gt.write(Zu);
                this.writeRootRefPath(n);
                this.Gt.write(Zu);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Gt.write(t + nc);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Gt.write(t + nc + n);
        } else if (typeof n === "string") {
            this.Gt.write(t + nc);
            this.outputString(n);
        } else {
            this.Gt.write(t + nc);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Bn.getSeenRef(t);
        const o = !e && this.Yn.get(t);
        if (s) {
            s.Gn && this.isSeenInStreamedRoot(s) && (s = this.Bn.ie(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Bn.se(t, this.Gn, n);
            }
            s = this.Bn.Pt(t, !0);
        }
        if (s.Gn) {
            if (this.Gn) {
                this.Bn.oe(s, t);
            } else {
                this.Bn.oe(s, t, n);
                t = this.Bn.le[n];
            }
        }
        if (typeof o === "number") {
            this.At[o] = s.Dt;
            this.Yn.delete(t);
        }
        const r = t instanceof wc ? t.ue : s.Dt;
        if (!this.Gn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Gn; ) {
            t = t.Gn;
        }
        return t.Dt < this.Kn;
    }
    writeValue(t, n) {
        if (gf(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === $s) {
                    this.output(3, 7);
                } else if (t === ms) {
                    this.output(3, 8);
                } else if (t === is) {
                    this.output(3, 9);
                } else {
                    if (t !== ec) {
                        throw rr(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === ho) {
                    this.output(3, 10);
                } else if (t === fo) {
                    this.output(3, 11);
                } else if (fr(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = Ln(this.Bn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Bn.Pt(n);
                            const i = this.Bn.Pt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.Zn.get(l);
                            if (u) {
                                const t = this.Bn.Pt(u);
                                this.output(1, t);
                                return;
                            }
                            this.Zn.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!za(t)) {
                        throw rr(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Wa];
                        this.Bn.ce.add(n.Et);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === ss) {
                    this.output(3, 5);
                } else if (t === os) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof wc) {
                    this.output(1, t.ue);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Gn;
                        this.Gn = e;
                        this.writeObjectValue(t);
                        this.Gn = n;
                    }
                }
                break;

              default:
                throw rr(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (ps(t)) {
            const n = t[ns];
            this.output(38, [ $c(n), n.varProps, n.constProps, t[es].dt ]);
        } else if (t instanceof Ds) {
            const {X: n, st: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof ys) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof oc) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (Hu(t)) {
            const n = zu(t);
            const e = Vu(t);
            const s = n.h;
            const o = n.dt;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Bn.wt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Lu(t)) {
            const n = t[kf](t);
            if ($i(n)) {
                const t = this.resolvePromise(n, (t, n) => new uc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Gn.Dt;
                this.Gn = this.Gn.Gn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        gf(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Bn.fe(t)) {
            this.Bn.ae(t.he, 16);
            this.output(11, t.he.id);
        } else if (t instanceof _s) {
            if (t instanceof ks) {
                const n = function e(t, n) {
                    if (n === $s) {
                        return n;
                    }
                    return wi(t.zt.resolved || t.zt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && kf in n && (e = n[kf](n));
                        e === void 0 && (e = $s);
                        return e;
                    });
                }(t, t.Wt);
                if ($i(n)) {
                    const e = this.resolvePromise(n, (n, e) => new uc(34, n, e, t.dt, t.zt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.zt, t.dt, n ]);
                }
                return;
            }
            if (t instanceof Xs) {
                this.output(31, [ ...Dn(this.Bn, t), t.h, t.R, ...t.dt || [] ]);
            } else if (t instanceof Es) {
                let n = t.Wt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = gf(t.Wt);
                const i = !!(t.h & 512);
                const c = i && !!t.Vt;
                const l = i && t.Bt !== 1 ? t.Bt : void 0;
                const u = i && t.Ht !== 0 ? t.Ht : void 0;
                const f = i && t.h & -25 || void 0;
                o || r || c ? n = $s : e ? n = t.Wt : s && (n = $s);
                const a = [ t.zt, t.dt ];
                if (i) {
                    const n = t.Vt;
                    a.push(t.vt, t.bt, n === void 0 ? n : Cf(n));
                    a.push(f || void 0);
                }
                n === $s && l === void 0 && u === void 0 || a.push(n === void 0 ? ec : n);
                if (i) {
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Wt;
                const e = [ n === void 0 ? ec : n ];
                t.dt && e.push(...t.dt);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            for (const e of Object.entries(t)) {
                n.push(e[0], e[1]);
            }
            this.output(23, n);
        } else if (this.Bn.de(t)) {
            if (t.vnodeData && t.vnodeData[0] & 32 && /[A-Za-z]/.test(t.id)) {
                this.output(3, 0);
                return;
            }
            const n = this.Bn.Pt(t);
            this.Bn.pe(t, Wr, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                if (!this.te.has(e)) {
                    this.te.add(e);
                    cc(e, this.Bn);
                }
                this.Bn.ae(t, 16, !0);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Bn.ae(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Us(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Au) {
            const n = [ t.gt, t.h, t.Dt, t.$t ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if ($i(t)) {
            const n = this.resolvePromise(t, (t, n) => new uc(24, t, n));
            this.output(2, n);
        } else if (t instanceof uc) {
            if (t.$e === 34) {
                if (t.gt) {
                    this.output(34, [ t.gt, t.dt, t.ye ]);
                } else {
                    if (!t.we) {
                        console.error(t.ye);
                        throw rr(33);
                    }
                    {
                        const n = this.Gn.Dt;
                        this.Gn = this.Gn.Gn;
                        this.writeValue(t.ye, n);
                    }
                }
            } else {
                this.output(24, [ t.we, t.ye ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof pc) {
            const n = t.ve;
            if (this.getSeenRefOrOutput(n, this.Gn.Dt, !0)) {
                let t = this.Yn.get(n);
                if (t === void 0) {
                    t = this.Hn++;
                    this.Yn.set(n, t);
                    this.At[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.ne && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.ne && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.ne && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.ne && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!yl(t)) {
                throw rr(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Hn++;
        t.then(s => {
            this.Jn.delete(t);
            this.At[e] = this.Bn.Pt(n(!0, s));
        }).catch(s => {
            this.Jn.delete(t);
            this.At[e] = this.Bn.Pt(n(!1, s));
        });
        this.Jn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Bn.me + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {le: n} = this.Bn;
        for (;this.Qn < n.length || this.Jn.size; ) {
            let e = t > 0;
            for (;this.Qn < n.length; this.Qn++) {
                e ? this.Gt.write(nc) : e = !0;
                this.writeValue(n[this.Qn], this.Qn);
                t++;
            }
            if (this.Jn.size) {
                try {
                    await Promise.race(this.Jn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Jn.size; ) {
            if (e < t.length) {
                n ? this.Gt.write(nc) : n = !0;
                const s = t[e++];
                this.writeValue(this.Bn.le[s], s);
                continue;
            }
            try {
                await Promise.race(this.Jn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.At.length - 1;
        for (;t >= 0 && this.At[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.At.length - 1 ? this.At : this.At.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Gt.write(Zu);
                this.writeRootRefPath(t);
                this.Gt.write(Zu);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Gt.write(Ku);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Bn.be = this.Bn.le.length;
        this.Bn._e = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Gt.write(nc);
            this.Gt.write(14 + nc);
            this.outputForwardRefsArray(n);
        }
        this.Gt.write(tc);
        this.Bn.ge = this.Bn.le.length + (this.Bn._e ? 1 : 0);
        this.Bn.ee = e;
    }
}

class uc {
    $e;
    we;
    ye;
    dt;
    gt;
    constructor(t, n, e, s, o) {
        this.$e = t;
        this.we = n;
        this.ye = e;
        this.dt = s;
        this.gt = o;
    }
}

const cc = (t, n) => {
    const e = t.length;
    for (let s = 1; s < e; s++) {
        const e = t[s];
        if (fc(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === Wr || t === Vr && (Ws(s) || ac(e, s))) {
                    continue;
                }
                n.Pt(s);
            }
        }
    }
};

const fc = t => typeof t === "object" && t !== null && !Ws(t);

const ac = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, ar)) {
        return !1;
    }
    const s = n[ns];
    return Ws(s.varProps) && !hc(n) && !dc(t[Rr]);
};

const hc = t => !!t[es].dt?.size;

const dc = t => t instanceof Map && t.has(":");

function Dn(t, n) {
    n.qt && n.qt[0] === "{" && (n.qt = `(${n.qt})`);
    const e = t.kt(n.qt, n.ft.length, n.ct);
    return [ e, n.ft ];
}

class pc {
    ve;
    constructor(t) {
        this.ve = t;
    }
}

const $c = t => new pc(t);

let yc = () => !1;

class wc {
    ue;
    constructor(t) {
        this.ue = t;
    }
}

Fi(wc, 2097152);

class vc {
    NodeConstructor;
    DomRefConstructor;
    Rt;
    pe;
    wt;
    Gt;
    Ee=new Map;
    Se=new Map;
    ke=0;
    Re=[];
    le=[];
    Pe=[];
    qe;
    me=0;
    ge=0;
    ee=0;
    be=0;
    _e=!1;
    Ae=new Set;
    Xt=new Set;
    Ft=new Set;
    ce=new Set;
    Te;
    ae=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.Rt = e;
        this.pe = s;
        this.wt = o;
        this.Gt = r;
        this.Te = new lc(this);
    }
    async Yt() {
        await this.Te.serialize();
    }
    async Ie(t, n, e, s) {
        await this.Te.serializePatch(t, n, e, s);
    }
    re(t) {
        this.Gt = t;
        this.Te.re(t);
    }
    getSeenRef(t) {
        return this.Ee.get(t);
    }
    se(t, n, e) {
        const s = {
            Dt: e,
            Gn: n
        };
        this.Ee.set(t, s);
        return s;
    }
    Me(t) {
        const n = [];
        for (;t.Gn; ) {
            n.unshift(t.Dt);
            t = t.Gn;
        }
        n.unshift(t.Dt);
        return n;
    }
    oe(t, n, e) {
        const s = this.Me(t);
        const o = e === void 0;
        e === void 0 && (e = this.le.length);
        this.le[e] = new wc(s);
        o && (this.Pe[e] = n);
        t.Gn = null;
        t.Dt = e;
        o && this.qe?.(e, this.le[e], n);
    }
    Pt(t, n = !1) {
        let e = this.Ee.get(t);
        let s;
        if (e) {
            e.Gn && this.oe(e, t);
            s = e.Dt;
        } else {
            s = this.le.length;
            e = {
                Dt: s
            };
            this.Ee.set(t, e);
            this.le.push(t);
            this.Pe.push(t);
            this.qe?.(s, t, t);
        }
        return n ? e : s;
    }
    ie(t) {
        const n = this.le.length;
        const e = {
            Dt: n
        };
        this.Ee.set(t, e);
        this.le.push(t);
        this.Pe.push(t);
        this.qe?.(n, t, t);
        return e;
    }
    xe(t, n) {
        const e = this.le.length;
        const s = {
            Dt: e
        };
        this.Ee.set(n, s);
        this.le.push(t);
        this.Pe.push(n);
        return e;
    }
    de(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    fe(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Ne(t) {
        const n = this.Ee.get(t);
        return n && (n.Gn ? void 0 : n.Dt);
    }
    kt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.Se.get(t);
        if (o === void 0) {
            o = this.ke + this.Re.length;
            this.Se.set(t, o);
            if (s) {
                this.Re.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Re.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Ce(t, n) {
        this.ke = t;
        if (n) {
            this.Se.clear();
            for (let t = 0; t < n.length; t++) {
                this.Se.set(n[t], t);
            }
        }
    }
}

const zd = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Gu(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    yc = n ? t => t instanceof n : () => !1;
    return new vc(t, n, e, s, o, r);
};

const mc = (t, n) => t[n];

const bc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        Hu(t) && (t = Vu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!bc(sa(mc, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!bc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Tu(t)) {
            return !0;
        }
        if (ps(t)) {
            return !0;
        }
        if ($i(t)) {
            return !0;
        }
        if (Us(t)) {
            return !0;
        }
        if (Lu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ds) {
            return !0;
        }
        if (yc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (fr(t) || za(t) || t === ho || t === fo) {
            return !0;
        }
    } else if (t === is || t === $s || t === ms) {
        return !0;
    }
    return !1;
};

const _c = (t, n) => {
    let e = yl(t) ? kn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Ke(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let gc = !1;

const Ec = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (gc = !0);
            const n = `{${Ke(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${_c(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = kc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Ec(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Sc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = gc ? "" : `(${JSON.stringify(t).length} chars)`;
        gc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Sc = t => sc[t] || `Unknown(${t})`;

const kc = t => ic[t] || `Unknown(${t})`;

function Wn(t, n, e, s = 0) {
    const o = zn(t, n, s);
    for (;!o.next().done; ) {}
}

function* zn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.At = t[i + 1]);
        yield;
    }
}

const Rc = /*#__PURE__*/ lr("resolvers", () => new WeakMap);

const Pc = /^[A-Za-z0-9+/]*$/;

const qc = t => {
    const n = t.Jt === void 0;
    t.Jt ??= new Map;
    return n;
};

const Ac = (t, n) => {
    if (n) {
        t.Jt.clear();
        t.Jt = void 0;
    }
};

const Tc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.q(e);

      case 2:
        const s = t.Kt(e);
        return s === -1 || s === void 0 ? is : t.q(s);

      case 14:
        return e;

      case 3:
        return rc[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t.q(i);
                const f = t.q(l);
                n = Fn(u, f, r !== -1 ? s : null, t);
            } else {
                n = Fn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Au(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Da(null);

      case 30:
        return new _s(t, 0);

      case 31:
        return new Xs(t, null, null, null);

      case 32:
        return new Es(t, null);

      case 33:
        return new Rs(t, null, void 0, {});

      case 34:
        return new ks(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Tc(t, s, o);
            const i = Ju(r, 0, t);
            ff(s) && t.Jt.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new zs(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Rc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !Pc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw rr(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return y(null);

      case 10:
        return Vn(t, e);

      case 11:
        const l = Vn(t, e);
        if (yl(l)) {
            tu(l);
            return bu(l);
        }
        throw rr(17, [ typeof l ]);

      case 39:
        return new Ds({});

      case 42:
        return new Ds({
            X: null,
            st: !0
        });

      case 43:
        return new Ds({
            X: null,
            st: !1
        });

      case 40:
      case 44:
        return new ys(null, null, null, null);

      case 41:
        return new oc;

      default:
        throw rr(18, [ n ]);
    }
};

function Vn(t, n) {
    return n ? t.rootVNode ? Ml(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Ic = (t, n, e) => {
    let s = null;
    let o = null;
    if (er(t)) {
        o = t;
    } else {
        if (!nr(t)) {
            throw rr(7, [ t ]);
        }
        s = t;
    }
    return Aa(s, n, null, o, e);
};

const Mc = (t, n, e) => Aa(null, n, t, null, e);

const xc = (t, n) => Aa(null, t, null, null, n);

const Nc = (t, n, e) => {
    const s = xc(t, e);
    return s;
};

const Cc = (t, n, e, s) => Aa(t, e, null, n, s);

const Oc = (t, n, e, s, o) => {
    const r = Cc(t, n, e, o);
    r.Oe(s);
    return r;
};

const jc = (t, n, e, s) => {
    const o = Ic(t, n, s);
    return o;
};

const Lc = (t, n, e, s) => {
    const o = Mc(t, n, s);
    return o;
};

const Fc = (t, n) => {
    (() => lr("regSymbols", () => new Map))().set(n, t);
    return t;
};

const Xc = t => {
    const n = t.Le.je;
    n == null || $i(n) || Fc(n, t.getHash());
};

function Un(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Dc = (t, n, e) => new Xs(null, t, n, e || null);

class Wc {
    Fe;
    wt;
    yn=null;
    xt=!1;
    an;
    q;
    $n;
    Xe=0;
    tn=null;
    De=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.$n = t;
        this.an = n;
        this.Fe = Qe;
        this.wt = new WeakMap;
        this.q = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return ua(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        if (ze) {
            return zd(t, n, e, this.setHostProp.bind(this), this.wt, s);
        }
        throw Error("Serialization context is only available on the server");
    }
    yt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const zc = /*#__PURE__*/ or("qInternalServerComponent");

const Vd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[zc] = t;
    return n;
};

class Vc {}

class Uc {}

const Bc = t => {
    const n = t.Tt;
    return !!n && (n.vnodeData[0] & 32) !== 0;
};

const Qc = t => {
    t.catch(() => {});
};

function Bn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Qn(n, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = t => {
        Qc(t);
        o.push(t);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            let e = "render";
            try {
                const c = o.pop();
                if (c === Vc) {
                    const s = o.pop();
                    if (__EXPERIMENTAL__.catchBoundary && Bc(n)) {
                        continue;
                    }
                    e = "hook";
                    await t(() => o.push(s()));
                    continue;
                }
                if (__EXPERIMENTAL__.catchBoundary && c === Uc) {
                    const t = o.pop();
                    if (Bc(n)) {
                        continue;
                    }
                    const e = t.apply(n);
                    $i(e) && await e;
                    continue;
                }
                if (typeof c === "function") {
                    if (c === Promise) {
                        const t = o.pop();
                        if (__EXPERIMENTAL__.catchBoundary && Bc(n)) {
                            continue;
                        }
                        o.push(await t);
                    } else {
                        const t = c.apply(n);
                        $i(t) && await t;
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.catchBoundary && Bc(n)) {
                    $i(c) && c.catch(() => {});
                    continue;
                }
                Jn(n, r, i, c, s);
            } catch (t) {
                n.handleError(t, n.getOrCreateLastNode(), e);
            } finally {
                const t = n.streamHandler.waitForPendingFlush();
                $i(t) && await t;
            }
        }
    })();
}

function Hn(t, n) {
    t(n);
    __EXPERIMENTAL__.catchBoundary && typeof n === "function" && t(Uc);
}

function Jn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                Hn(n, s[t]);
            }
        } else if (Mu(s)) {
            t.openFragment(os);
            const e = t.getOrCreateLastNode();
            const o = s instanceof Xs ? s.lt() : s;
            n(t.closeFragment);
            n(() => ua(o, e, ".", t));
            n(Vc);
        } else if ($i(s)) {
            t.openFragment(os);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                if (__EXPERIMENTAL__.catchBoundary && Bc(t)) {
                    return;
                }
                const n = () => ({
                    currentStyleScoped: o.currentStyleScoped,
                    parentComponentFrame: o.parentComponentFrame
                });
                try {
                    for await (const e of s) {
                        await Qn(t, e, n());
                        await t.streamHandler.flush();
                    }
                } catch (e) {
                    t.handleError(e, t.getOrCreateLastNode(), "render");
                    await Qn(t, null, n());
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = fs(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                __EXPERIMENTAL__.catchBoundary && fs(r, br) && n(((t, n) => {
                    const e = t.Tt;
                    t.Tt = n;
                    return () => {
                        t.Tt = e;
                    };
                })(t, t.getOrCreateLastNode()));
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.It) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && Hn(n, l);
            } else if (er(i)) {
                if ((__EXPERIMENTAL__.pendingBoundary || __EXPERIMENTAL__.catchBoundary) && (t => typeof t === "function" && zc in t)(i)) {
                    n(() => (t => t[zc])(i)(t, r, o, n));
                    return;
                }
                if (i === fo) {
                    const e = r.key != null ? {
                        [zr]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && Hn(n, s);
                } else if (i === ho) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        i[yr] = s;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = R(c, r, t);
                        i[$r] = u;
                        n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = r.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        Hn(n, a);
                        n(Bn(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = os;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === yo) {
                    t.commentNode(fs(r, "data") || "");
                } else if (i === vo) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = er(s) ? s({
                        async write(n) {
                            await Qn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    $i(i) ? e(i) : n(i);
                } else if (i === $o) {
                    t.htmlNode(fs(r, "data"));
                } else if (i === wo) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    Hn(n, r.children);
                } else if (za(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Wa];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(ar, o);
                        s.setProp(Vr, r);
                        n.key !== null && s.setProp(zr, n.key);
                        return Ko(t, s, s, o, r);
                    })(t, r, i);
                    if ($i(l)) {
                        Qc(l);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = Ro(s.getProp(Sr));
                            n(e);
                            n(Bn(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = Ro(s.getProp(Sr));
                        n(Bn(o, t, c));
                    }
                } else {
                    const s = {
                        [zr]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Ko(t, o, n, e, s.props);
                    })(t, o && o.componentNode, i, r);
                    $i(c) ? e(c) : n(c);
                }
            }
        }
    }
}

function Yn(t, n, e, s) {
    if (!__EXPERIMENTAL__.catchBoundary) {
        throw n;
    }
    for (let o = e; o; o = o.parentComponent) {
        const e = Zn(o);
        if (!e || !e.Mt) {
            continue;
        }
        if (t.xt && e.Nt) {
            throw n;
        }
        Wf(e, n, s);
        bi(t).Ct = !0;
        t.xt && Ff(e);
        Gn(t, o, e);
        return;
    }
    throw n;
}

function Gn(t, n, e) {
    const s = new Map;
    let o = null;
    let r = 0;
    for (let t = n; t; t = t.parentComponent) {
        t.id && s.set(t.id, {
            node: t,
            depth: r++
        });
        if (t !== n && !o) {
            const n = Zn(t);
            n?.error === void 0 && t.hasSlotProps() || (o = t);
        }
    }
    const i = {
        node: null,
        depth: -1
    };
    const c = n.children;
    if (c) {
        for (let n = 0; n < c.length; n++) {
            Kn(t, c[n], s, i);
        }
    }
    if (i.node) {
        const s = i.node.parentComponent;
        if (i.node === n) {
            t.Ot(o);
        } else if (s?.id) {
            t.Ot(s);
            e.projectedContentOwner = s;
        }
    }
}

function Zn(t) {
    const n = t.getProp(kr);
    return n ? ai(n, Tf.id, 0) : null;
}

function Kn(t, n, e, s) {
    n.vnodeData[0] |= 32;
    const o = n.getProp(yr);
    if (o) {
        const t = e.get(o);
        if (t) {
            t.node.removeProp(n.getProp($r) ?? "");
            if (t.depth > s.depth) {
                s.node = t.node;
                s.depth = t.depth;
            }
        }
    }
    Pn(t, n);
    const r = n.getProp(Ur);
    if (r) {
        for (let n = 0; n < r.length; n++) {
            const e = r[n];
            Tu(e) && Pn(t, e);
        }
    }
    const i = n.children;
    if (i) {
        for (let n = 0; n < i.length; n++) {
            Kn(t, i[n], e, s);
        }
    }
}

const Hc = () => {
    const t = ga._;
    return t;
};

const Jc = async t => {
    const [n, e] = ga._;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = Nn(n.k, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Yc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Vo();
    if (e) {
        return e;
    }
    const r = Aa(null, "_rsc", Jc, null, [ t, {} ], o.k);
    const i = As(r, {
        timeout: n?.timeout,
        container: o.k,
        concurrency: 0
    });
    i.$();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Gc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if ($i(t)) {
        return t.then(n, s);
    }
    const o = Zc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return $i(i) ? i.then(n, s) : n(i);
};

const Zc = t => t && t.__brand === "resource";

function te(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        !n.Et.startsWith("_") && (Array.isArray(n.jt) || s && n.Lt) && (n = Aa(null, "_run", C, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = Ln(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (fr(o)) {
                i(c(o));
                ne(t, n, o);
            } else if (o != null) {
                const e = te(t, n, o, s);
                e && i(e);
            }
        }
    } else if (fr(r)) {
        o = c(r);
        ne(t, n, r);
    }
    return o;
}

function ne(t, n, e) {
    const s = Oi(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Ft.add(r);
        t.Xt.add(e);
    }
}

const Kc = (t, n, e) => {
    ef(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const tf = (t, n, e) => {
    ef(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const nf = (t, n, e) => {
    ef(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const ef = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = rf();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Ci(i), e, s);
            }
        } else {
            r(t + Ci(n), e, s);
        }
    }
};

const rf = () => {
    const t = ra();
    const n = t.R;
    const e = n;
    let s = t.k.getHostProp(e, Yr);
    if (s === null) {
        s = {};
        t.k.setHostProp(e, Yr, s);
    }
    let o = t.k.getHostProp(e, Gr);
    o === null && (o = 0);
    t.k.setHostProp(e, Gr, o + 1);
    let r = t.k.getHostProp(e, Zr);
    if (r === null) {
        r = [];
        t.k.setHostProp(e, Zr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const sf = function(t, n) {
    const e = Ie(n);
    return Gf(e, () => {
        typeof this === "string" && Sa(ka(e, this));
        const s = ga._?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = ga._?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        vn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let of;

function ee(t) {
    const n = na();
    if (!n) {
        return;
    }
    of ||= Mc(sf, "_hmr");
    const e = n.R;
    const s = of.w([ e, t ]);
    tf("qHmr", s);
}

function re(t, n, e, s, o) {
    const r = $l();
    Sl(r, $r, o);
    r.parent = n;
    Sl(n, o, r);
    Sl(r, ar, e);
    Sl(r, Vr, s);
    r.dirty = 4;
    pn(t, r, 1);
    return r;
}

function ie(t, n) {
    Sl(t, dr, n);
    t.flags |= 2048;
}

function se(t, n, e) {
    Sl(n, Vr, e);
    vn(t, n, 4);
}

function oe(t, n, e, s) {
    Sl(n, s, null);
    const o = [];
    kt(t, o, e);
    Ll(o);
    if (e.flags & 2048) {
        const t = El(e, dr, null);
        t && t.replaceChildren();
        Sl(e, dr, null);
        e.flags &= -2049;
    }
}

const lf = /*#__PURE__*/ lr("loadingHolder", () => ({
    p: Promise.resolve()
}));

const uf = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const cf = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !uf.has(t));
};

function* le(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ce(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ue(t, n, e = Array(n.length / 2)) {
    const s = qc(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t.q;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : Tc(t, i, c);
        }
        return e[s];
    };
    t.q = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            ff(r) && (yield* fe(t, c, r, i));
            yield;
        }
    } finally {
        t.q = i;
        Ac(t, s);
    }
    return e;
}

function* ce(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Tc(t, n, e);
    ff(n) && (yield* fe(t, s, n, e));
    return s;
}

function* fe(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* le(t, s));
    switch (e) {
      case 4:
        yield* le(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!cf(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Rc.get(t);
            if (e) {
                if (Rc.has(o)) {
                    throw rr(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                cf(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t.gt = e[0];
            t.h = e[1];
            t.Dt = e[2];
            t.$t = e[3];
            break;
        }

      case 29:
        n[Wa][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Wt = e[0];
            t.dt = new Set(e.slice(1));
            he(t.dt, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ct = t.getSyncFn(o[0]);
            e.ft = o[1];
            e.Wt = $s;
            e.h = o[2];
            e.h |= 1;
            e.R = o[3];
            e.dt = new Set(o.slice(4));
            (function r(t) {
                if (t.R !== null && yl(t.R)) {
                    const n = t.R;
                    const e = t.dt;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (nr(e)) {
                                const o = El(n, e, null);
                                if (o !== null) {
                                    t.Wt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Kl(n);
                        e && n.firstChild === n.lastChild && bl(e) && (t.Wt = Gl(e));
                    }
                }
            })(e);
            he(e.dt, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.zt = e[0];
            e[1] && (t.dt = new Set(e[1]));
            e[2] && (t.vt = new Set(e[2]));
            e[3] && (t.bt = new Set(e[3]));
            e[4] && (t.Vt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Ut = !0);
            const o = e.length > 6;
            o && (t.Wt = e[6]);
            t.Wt === $s && (t.h |= 1);
            if (e[7] !== void 0 && e[7] !== 1) {
                t.Bt = e[7] ?? 1;
                t.Qt = [];
            }
            t.Ht = e[8] ?? 0;
            he(t.dt, t);
            he(t.vt, t);
            he(t.bt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.zt = r[0];
            const i = o.zt.resolve(t).catch(() => {});
            lf.p = lf.p.finally(() => i);
            r[1] && (o.dt = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Wt = r[2]);
            e !== 34 && o.Wt !== $s && (o.h &= -2);
            he(o.dt, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === is) {
                o = new zs(fo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[ns] = o;
            const r = t[es];
            r.dt = e[3];
            de(r.dt, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.X = s[0];
            t.data.st = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            ae(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            ae(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Qu(n);
            const o = t.Jt.get(e);
            if (o) {
                t.Jt.delete(e);
                yield* fe(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = zu(n);
            c.h = r;
            c.dt = i;
            de(c.dt, e);
            break;
        }

      default:
        throw rr(16, [ e ]);
    }
}

function ae(t) {
    const n = ze;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[_i] ||= new Map;
    e[_i].set(t.property, t);
}

function he(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function de(t, n) {
    if (t) {
        for (const [, e] of t) {
            he(e, n);
        }
    }
}

const ff = t => t >= 23 || t === 4 || t === 5;

const af = /*#__PURE__*/ lr("deserializedProxyMap", () => new WeakMap);

const hf = /*#__PURE__*/ or("UNWRAP");

const df = (t, n) => {
    if (!Array.isArray(n) || yl(n) || (t => Ke(t) && hf in t)(n)) {
        return n;
    }
    let e = af.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new pf(t, n));
        af.set(n, e);
    }
    return e;
};

class pf {
    k;
    We;
    constructor(t, n) {
        this.k = t;
        this.We = n;
    }
    get(t, n, e) {
        if (n === hf) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.We.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.We[o];
        const i = this.We[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.k;
        const l = qc(c);
        try {
            const e = Tc(c, r, i);
            Reflect.set(t, n, e);
            this.We[o] = 0;
            this.We[o + 1] = e;
            ff(r) && ((t, n, e, s) => {
                const o = qc(t);
                try {
                    const o = fe(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    Ac(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            Ac(c, l);
        }
    }
    has(t, n) {
        if (n === hf) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === hf) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.We.length / 2) {
            return o;
        }
        const i = r * 2;
        this.We[i] = 0;
        this.We[i + 1] = e;
        return !0;
    }
}

const $f = t => {
    if (!t.ze) {
        t.ze = !0;
        t.Ve();
    }
};

const yf = (t, n, e) => {
    const s = {
        Ue: t,
        Ve: void 0,
        ze: !1
    };
    const o = il(() => {
        ((t, n, e) => {
            t.ze = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Ue.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        $f(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.Xn?.();
            n(t);
        }, t => {
            o.Xn?.();
            e(t);
        });
    });
    s.Ve = o;
    return s;
};

async function pe(t) {
    const n = zd(null, null, () => "", () => {}, new WeakMap);
    n.Pt(t);
    await n.Yt();
    return n.Gt.toString();
}

async function $e(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = ve(n, () => e);
    s.Zt = e;
    await wf(ue(s, n, e));
    return e[0];
}

const wf = t => new Promise((n, e) => {
    const s = yf(t, n, e);
    $f(s);
});

function ye(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function we(t) {
    let n;
    const e = ve(t, () => n);
    n = df(e, t);
    e.Zt = n;
    return e;
}

function ve(t, n) {
    const e = {
        q: t => ye(t, n()),
        Kt: t => e.At?.[+t],
        getSyncFn: () => () => {},
        wt: new WeakMap,
        element: null,
        At: null
    };
    Wn(t, e);
    return e;
}

const vf = (t, n) => {
    const e = new WeakSet;
    return sa(mf, t, e, "_", n);
};

const mf = (t, n, e, s) => {
    const o = Qu(t);
    if (o == null) {
        return t;
    }
    if (_f(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Mu(o)) {
            return t;
        }
        if (bc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if ($i(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (tr(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw rr(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw rr(3, [ o ]);
                    }
                    mf(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Xi) {
                return t;
            }
            if (Ze(o)) {
                for (const [t, s] of Object.entries(o)) {
                    mf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw rr(3, [ i ]);
    }
    return t;
};

const bf = /*#__PURE__*/ lr("noSerialize", () => new WeakSet);

const _f = t => {
    if (Ke(t) || er(t)) {
        return !bf.has(t) && !(Sf in t);
    }
    return !0;
};

const gf = t => !!t && (Ke(t) || typeof t === "function") && (bf.has(t) || Sf in t);

const Ef = t => {
    (Ke(t) && t !== null || typeof t === "function") && bf.add(t);
    return t;
};

const Sf = /*#__PURE__*/ or("noSerialize");

const kf = /*#__PURE__*/ or("serialize");

const Rf = t => /*#__PURE__*/ Object.freeze({
    id: Ci(t)
});

const Pf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Vo();
    if (e !== void 0) {
        return;
    }
    o.k.setContext(o.R, t, n);
    s(1);
};

const qf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Vo();
    if (e !== void 0) {
        return e;
    }
    const r = o.k.resolveContext(o.R, t);
    if (typeof n === "function") {
        return s(je(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw rr(8, [ t.id ]);
};

const Af = t => {
    const n = ea();
    const e = n.R;
    if (!e) {
        return;
    }
    return n.k?.resolveContext(e, t);
};

const Tf = /*#__PURE__*/ Rf("qk-error");

const If = (t, n) => {
    try {
        return t();
    } catch {
        return n;
    }
};

const Mf = "An error occurred";

const xf = t => qo(If(() => t instanceof Error ? `${t.name}: ${t.message}\n${t.stack ?? ""}` : t + "", "unknown"));

const Nf = /*#__PURE__*/ or("redacted");

const Cf = t => {
    const n = Error(Mf);
    n.digest = xf(t);
    Object.defineProperty(n, Nf, {
        value: !0
    });
    return n;
};

const Of = t => {
    if (t instanceof Error) {
        return t;
    }
    let n;
    try {
        n = t + "";
    } catch {
        try {
            n = Object.prototype.toString.call(t);
        } catch {
            n = Mf;
        }
    }
    const e = Error(n);
    e.cause = t;
    return e;
};

const Ud = (t, n, e) => {
    try {
        if (e) {
            const s = e(t);
            if (s instanceof Error) {
                return (t => If(() => {
                    t.message;
                    t.name;
                    for (const n in t) {
                        t[n];
                    }
                    return !0;
                }, !1))(s) ? s : Cf(t);
            }
            if (s != null) {
                n && $i(s);
                return Cf(t);
            }
        }
        if (If(() => t instanceof Error && Nf in t, !1)) {
            return t;
        }
        if (!n) {
            return Cf(t);
        }
        if (t instanceof Error) {
            return t;
        }
        const s = t?.message;
        if (typeof s === "string") {
            const n = Error(s);
            n.cause = t;
            return n;
        }
        return Of(t);
    } catch {
        return Cf(t);
    }
};

const jf = (t, n, e, s) => {
    if (!t) {
        return;
    }
    try {
        const o = xf(n);
        Promise.resolve(t(Of(n), {
            phase: e,
            boundaryId: s,
            digest: o
        })).catch(Je);
    } catch (t) {
        Je(t);
    }
};

const Lf = /*#__PURE__*/ lr("deferredErrorBoundaries", () => new WeakSet);

const Ff = t => {
    Lf.add(t);
};

const Xf = /*#__PURE__*/ or("qErrorPhase");

const Df = (t, n) => {
    try {
        Object.defineProperty(t, Xf, {
            value: n,
            configurable: !0
        });
    } catch {}
};

const Wf = (t, n, e = "render") => {
    t.error = n ?? Of(n);
    const s = t.Be;
    s && jf(s, n, (t => If(() => t?.[Xf], void 0))(n) ?? e, t.boundaryId ?? "");
};

const zf = t => {
    const n = t.detail;
    if (n?.importError) {
        return;
    }
    const e = n.element;
    if (!e || e.ownerDocument !== t.currentTarget) {
        return;
    }
    const s = e.closest(Or)?.qContainer;
    const o = s?.vNodeLocate(e);
    if (!s || !o) {
        return;
    }
    try {
        s.handleError(n.error, o, "event");
    } catch (t) {
        Je(t);
    }
};

function me(t, n) {
    const e = t.getHostProp(n, kr);
    return e ? ai(e, Tf.id, 0) : null;
}

const Bd = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Qd = /*#__PURE__*/ lr("outOfOrderRevealIds", () => new WeakMap);

class Hd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Jd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Bd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Jd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Yd = () => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return !1;
    }
    const t = na()?.k;
    return t?.outOfOrderStreaming === !0 && !Dd(t);
};

const Vf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && ju(t, n, r);
};

const Uf = /*#__PURE__*/ lr("processedStatePatchScripts", () => new WeakMap);

function* be(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.tn}"]${vr}`);
    const o = Bf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(mr) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* _e(t, e, i.textContent);
        yield;
    }
}

const Bf = t => {
    let n = Uf.get(t);
    if (!n) {
        n = new WeakSet;
        Uf.set(t, n);
    }
    return n;
};

function* _e(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.nn.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.nn[e * 2 + t] = s[t];
            yield;
        }
        yield* zn(n.nn, t, e * 2);
        n.en = df(t, n.nn);
        n.en.length = n.nn.length / 2;
        n.rn = n.At;
    }(t, n, s, o);
    Qf(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.pendingBoundary || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t.q(s.rootId);
            const r = s.subscriptions;
            if (o instanceof _s) {
                r instanceof Set && Vf(t, o, o, o.dt ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = zu(o);
                const e = Vu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.dt ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    Vf(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n.q(i));
}

const Qf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.rn ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.At = e;
};

const Hf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function ge(t, n) {
    const e = t.qVNodeDataState ||= {
        sn: [],
        ln: null
    };
    t.qProcessVNodeDataPatch ||= n => ge(t, ke(t, n));
    t.qVNodeDataReady = !1;
    e.sn.push(n);
    Ee(t, e);
}

function Ee(t, n) {
    if (n.ln) {
        return;
    }
    const e = n.sn.shift();
    if (!e) {
        Se(t);
        return;
    }
    n.ln = yf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.ln = null;
            Ee(t, n);
        }
    }, e => {
        n.ln = null;
        Je(e);
        Se(t);
    });
    $f(n.ln);
}

function Se(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* ke(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* Re(t, s || void 0, e, o, n.textContent));
}

function* Re(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const _ = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.pendingBoundary && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* _(s));
            yield;
        }
    };
    const m = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.pendingBoundary && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const b = t => {
        for (;t && (t = t.nextSibling) && m(t) === 0; ) {}
        return t;
    };
    const v = t => {
        let n = null;
        for (;t && !(n = b(t)); ) {
            t = t.parentNode;
        }
        return n;
    };
    const g = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.pendingBoundary && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let _ = 0;
        let E = -1;
        let k = null;
        const R = () => {
            let t = 0;
            for (;Jf(_ = r.charCodeAt(y)); ) {
                t += 1 << _ - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            k = null;
            const P = s == e ? 2 : m(s);
            if (P === 3) {
                const t = s;
                k = v(s);
                yield* g(n, t, s, k, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (P === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (m(t) !== 65);
            } else if (P === 64) {
                k = s;
                let t;
                do {
                    k = n.nextNode();
                    if (!k) {
                        throw Error("Ignore block not closed!");
                    }
                    t = m(k);
                } while (t !== 32 && t !== 65);
                k = null;
            } else if (P === 9) {
                k = s;
                do {
                    k = b(k);
                    if (!k) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (m(k) !== 8);
                yield* g(n, s, s, k, "", null, c);
            } else if (P === 6) {
                k = b(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* g(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((P & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += R();
                        if (_ === 126) {
                            E = p;
                            y++;
                            _ = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = Yf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.pendingBoundary && !u && P === 130 ? $.call(s, a) : null;
                if (h === p) {
                    E !== h || u && s === e || i.set(u ? qi(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== Pi || n.charCodeAt(1) !== Pi || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        P !== 3 && d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.pendingBoundary && t !== null) {
                    yield* S(c, s, t);
                    k = b(s);
                    k && (n.currentNode = k);
                }
            }
            yield;
        } while (s = k || n.nextNode());
    };
    const E = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* g(r, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const S = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* E(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.pendingBoundary && n !== void 0 ? yield* S(e, s, n, o) : yield* E(e, s, o);
        return;
    }
    yield* _(t);
    const k = t.createTreeWalker(t, 129);
    yield* g(k, null, k.firstChild(), null, "", null, null);
}

const Jf = t => 33 <= t && t <= 46;

const Yf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Jf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Pe(t) {
    return t.un === 3;
}

function qe(t, n) {
    const e = t.cn ||= {
        sn: [],
        ln: null
    };
    t.un = 2;
    e.sn.push(n);
    Ae(t, e);
}

const Gf = (t, n) => {
    const e = t;
    if (Pe(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!Pe(e)) {
                    (e.fn ||= []).push(s);
                    return;
                }
                Hf(e.document, () => {
                    Pe(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function Ae(t, n) {
    if (n.ln) {
        return;
    }
    const e = n.sn.shift();
    if (!e) {
        Te(t);
        return;
    }
    n.ln = yf(e, () => {
        n.ln = null;
        Ae(t, n);
    }, e => {
        n.ln = null;
        Je(e);
        Te(t);
    });
    $f(n.ln);
}

function Te(t) {
    const n = t.un;
    if (n !== 2) {
        return;
    }
    t.un = 3;
    t.cn = void 0;
    const e = t.fn;
    t.fn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Ie(t) {
    const n = xe(t);
    if (!n) {
        throw rr(24);
    }
    return Me(n);
}

function Me(t) {
    const n = t;
    return n.qContainer ||= new Zf(n);
}

function xe(t) {
    return t.closest(Or);
}

function Ne(t, n) {
    const e = t + "";
    const s = n?.closest(Or);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.pendingBoundary || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            ge(t, function* i(t, n, e, s, o, r) {
                yield* Re(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* ke(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        Hf(t, () => {
            o.element.qContainer === o && qe(o, be(o, e));
        });
    }
}

class Zf extends Wc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    wt=new WeakMap;
    Qe;
    tn;
    At=null;
    vNodeLocate=t => Ml(this.rootVNode, t);
    un=0;
    fn=void 0;
    cn=void 0;
    nn;
    en;
    rn=null;
    He=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(xr);
        if (!this.qContainer) {
            throw rr(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.De = t.getAttribute(qr);
        this.tn = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = dl(this.element);
        this.nn = [];
        this.en = [];
        __EXPERIMENTAL__.pendingBoundary && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= Ne);
        this.Qe = Pr(n, this.tn) || ss;
        this.Je();
        t.qContainer = this;
        t.qDestroy = () => this.Xn();
        __EXPERIMENTAL__.catchBoundary && function e(t) {
            if (!t.qErrorHandler) {
                t.qErrorHandler = zf;
                t.addEventListener?.("qerror", zf);
            }
        }(this.document);
        this.un = 1;
        (function s(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            ge(e, function* s(t) {
                yield* Re(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Hf(n, () => {
            this.un === 1 && qe(this, this.Ye());
        });
    }
    * Ye() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.tn}"]:not(${vr})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${vr})`);
        if (n) {
            this.nn = JSON.parse(n.textContent);
            yield* zn(this.nn, this);
            this.rn = this.At;
            const e = this.nn.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.en = s !== null && e > 0 && e >= +s ? yield* ue(this, this.nn) : df(this, this.nn);
        }
        __EXPERIMENTAL__.pendingBoundary && (yield* be(this));
        this.Ge();
        t.setAttribute(xr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    Xn() {
        this.vNodeLocate = () => null;
        this.nn.length = 0;
        this.en.length = 0;
        this.q = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.pendingBoundary && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(xr);
        const n = t.ownerDocument;
        this.cn = void 0;
        this.un = 0;
        const e = n.querySelector(Or) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.pendingBoundary && (e || (n.qProcessOOOS = void 0));
    }
    Ge() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Er);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    zn(t, n) {
        this.en[t] = n;
    }
    parseQRL(t) {
        return Xn(t, this);
    }
    handleError(t, n, e = "render") {
        if (!__EXPERIMENTAL__.catchBoundary) {
            const e = n && this.resolveContext(n, Tf);
            if (!e) {
                Ye(t);
                return;
            }
            e.error = t;
            return;
        }
        const s = t ?? Of(t);
        let o = n;
        for (;o; ) {
            const n = this.resolveContextHost(o, Tf);
            if (!n) {
                break;
            }
            const r = me(this, n);
            if (r && r.error === void 0) {
                r.error = s;
                const o = this.getHostProp(n, Vr);
                jf(o?.onError$, t, e, r.boundaryId ?? "");
                vn(this, n, 4);
                return;
            }
            if (n.dirty & 4) {
                Je(t);
                return;
            }
            o = this.getParentHost(n);
        }
        Ye(t);
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, kr);
        s == null && this.setHostProp(t, kr, s = []);
        fi(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        const e = this.resolveContextHost(t, n);
        return e ? ai(this.getHostProp(e, kr), n.id, 0) : void 0;
    }
    resolveContextHost(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, kr);
            if (e != null && hi(e, n.id, 0)) {
                return t;
            }
            t = this.getParentHost(t);
        }
        return null;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (_l(n)) {
                if (El(n, ar, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        Sl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Ur:
          case Vr:
          case ar:
          case kr:
          case Rr:
            s = this.q;
            break;

          case Br:
          case Gr:
            s = parseInt;
            break;
        }
        return El(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    q=t => ye(t, this.en);
    Kt(t) {
        return this.rn?.[t];
    }
    getSyncFn(t) {
        const n = this.Qe[t];
        return n;
    }
    Ze(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Sr);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Sr, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.He == null) {
            this.He = new Set;
            const t = this.document.querySelectorAll(gr);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.He.add(e.getAttribute(_r));
            }
        }
        if (!this.He.has(n)) {
            this.He.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(_r, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Je() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === ni) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.$n = {
            containerAttributes: t
        };
    }
}

Fi(Zf, 4096);

const Kf = /*#__PURE__*/ lr("localeStore", () => ({
    locale: void 0,
    asyncStore: void 0
}));

if (ze) {
    const t = Be();
    t && (Kf.asyncStore || (Kf.asyncStore = new t));
}

function Ce(t) {
    if (Kf.asyncStore) {
        const t = Kf.asyncStore.getStore();
        if (t) {
            return t;
        }
    }
    if (Kf.locale === void 0) {
        const n = na();
        if (n && n.an) {
            return n.an;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Kf.locale;
}

function Oe(t, n) {
    if (Kf.asyncStore) {
        return Kf.asyncStore.run(t, n);
    }
    const e = Kf.locale;
    const s = () => {
        Kf.locale = e;
    };
    Kf.locale = t;
    return yi(n, t => {
        s();
        return t;
    }, t => {
        s();
        throw t;
    });
}

const ta = /*#__PURE__*/ lr("invokeContext", () => ({
    current: void 0
}));

const na = () => ta.current;

const ea = () => {
    const t = na();
    if (!t) {
        throw rr(9);
    }
    return t;
};

const ra = () => {
    const t = na();
    if (!t || t.hn !== Xr) {
        throw rr(10);
    }
    return t;
};

function je(t, n, ...e) {
    return Le.call(this, t, n, e);
}

function Le(t, n, e) {
    const s = ta.current;
    try {
        ta.current = t;
        return n.apply(this, e);
    } finally {
        ta.current = s;
    }
}

const ia = (t, n, e = Ie(n)) => {
    const s = Ml(e.rootVNode, n);
    const o = e.an;
    o && function r(t) {
        if (Kf.asyncStore) {
            Kf.asyncStore.enterWith(t);
            return;
        }
        Kf.locale = t;
    }(o);
    const i = Xe(o, s, t);
    i.k = e;
    return i;
};

function Fe(t, n, e) {
    const s = {
        R: n,
        hn: Xr,
        dn: void 0,
        an: t,
        k: e,
        pn: void 0
    };
    return s;
}

function Xe(t, n, e) {
    const s = {
        R: n,
        hn: e,
        dn: void 0,
        an: t,
        k: void 0
    };
    return s;
}

const sa = (t, ...n) => {
    if (typeof t === "function") {
        if (!ta.current) {
            return t(...n);
        }
        {
            const e = ta.current.dn;
            try {
                ta.current.dn = void 0;
                return t(...n);
            } finally {
                ta.current.dn = e;
            }
        }
    }
    if (Mu(t)) {
        return t.untrackedValue;
    }
    return Qu(t);
};

const oa = /*#__PURE__*/ Fe(void 0, void 0, void 0);

const la = (t, n, e, s, o) => {
    const r = oa.dn;
    const i = oa.k;
    try {
        oa.dn = w(n, e, o);
        oa.k = s;
        return Le(oa, t);
    } finally {
        oa.dn = r;
        oa.k = i;
    }
};

const ua = (t, n, e, s, o) => {
    t instanceof Xs && t.R !== n && n && (t.R = n);
    return la(() => t.value, n, e, s, o);
};

const ca = () => na()?.R;

const fa = () => {
    const t = na();
    if (t) {
        return t.hn;
    }
};

const aa = () => {
    const t = na();
    if (t) {
        return t.k;
    }
};

const ha = t => t;

const da = t => t.l || Promise.resolve();

const pa = /*#__PURE__*/ lr("reportedChunkFailures", () => new WeakMap);

class $a {
    St;
    Et;
    Ke;
    je;
    k;
    constructor(t, n, e, s, o) {
        this.St = t;
        this.Et = n;
        this.Ke = e;
        this.je = s;
        s && this.tr(s);
        !o || s || typeof t !== "string" || e || (this.k = o);
        Ve && t && We(t, .8);
    }
    get ut() {
        return Ld(this.Et);
    }
    tr(t) {
        this.je = t;
        $i(t) && t.then(t => this.je = t, t => {
            const n = `qrl ${this.Et} failed to load`;
            if (ze) {
                console.error(n, t);
            } else if (Ve) {
                const e = this.St === null ? "symbol:" + this.Et : "chunk:" + this.St;
                const s = this.k;
                let o = s && pa.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            pa.set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.je = null;
        });
    }
    nr() {
        if (this.je != null) {
            return this.je;
        }
        if (this.St === "") {
            const t = this.k.tn;
            const n = this.k.element?.ownerDocument || document;
            const e = Pr(n, t);
            return this.je = e[+this.Et];
        }
        Ve && this.St && We(this.St, 1);
        const t = this.Et;
        const n = this.Ke ? this.Ke().then(n => n[t]) : ui().importSymbol(this.k?.element, this.St, t);
        this.tr(n);
        return this.je;
    }
}

const ya = /*#__PURE__*/ or("qrl-state");

const wa = t => t?.[ya] ?? t;

class va {
    Le;
    resolved=void 0;
    jt;
    k;
    constructor(t, n, e) {
        this.Le = t;
        if (n) {
            this.jt = n;
            typeof n === "string" && (this.k = e);
        }
        t.je == null || this.jt && typeof this.jt === "string" || $i(t.je) || (this.resolved = Pa(this, t.je));
    }
}

const ma = function(t, ...n) {
    const e = wa(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = na();
    return ba.call(e, s?.k).then(() => Le.call(t, s, e.resolved, n));
};

const ba = async function(t) {
    const n = wa(this);
    return wi(qa(n, t), () => n.resolved);
};

const _a = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[ya].resolved;
        },
        set(t) {
            this[ya].resolved = t;
        }
    },
    jt: {
        get() {
            return this[ya].jt;
        },
        set(t) {
            this[ya].jt = t;
        }
    },
    Lt: {
        get() {
            return this[ya].Le.Lt;
        }
    },
    k: {
        get() {
            return this[ya].k;
        },
        set(t) {
            this[ya].k = t;
        }
    },
    Le: {
        get() {
            return this[ya].Le;
        }
    },
    St: {
        get() {
            return this[ya].Le.St;
        }
    },
    Et: {
        get() {
            return this[ya].Le.Et;
        }
    },
    ut: {
        get() {
            return this[ya].Le.ut;
        }
    },
    dev: {
        get() {
            return this[ya].Le.dev;
        }
    },
    er: {
        value: ma
    },
    w: {
        value: function(t) {
            const n = wa(this);
            const e = new va(n.Le, t, n.jt ? n.k : void 0);
            return Ta(e);
        }
    },
    m: {
        value: function() {
            this[ya].Le.Lt = !0;
            return this;
        }
    },
    s: {
        value: function(t) {
            const n = wa(this);
            n.Le.tr(t);
            n.resolved = Pa(n, t);
        }
    },
    resolve: {
        value: ba
    },
    getSymbol: {
        value: function() {
            return wa(this).Le.Et;
        }
    },
    getHash: {
        value: function() {
            return wa(this).Le.ut;
        }
    },
    getCaptured: {
        value: function() {
            const t = wa(this);
            Ra(t);
            return t.jt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = wa(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return ba.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Le(t, e.resolved, o);
            };
            return s;
        }
    }
});

const ga = /*#__PURE__*/ lr("qrlCaptures", () => ({
    _: null
}));

let Ea = null;

const Sa = t => {
    Ea = ga._ = t;
};

const ka = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t.q(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const Ra = t => {
    const n = t.jt;
    const e = t.k;
    if (typeof n === "string") {
        if (!e) {
            throw rr(13);
        }
        const s = lf.p;
        const o = t.jt = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return ka(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return ka(t, n, s + 1, o);
        })(e, n);
        Sa(o);
        if (lf.p !== s) {
            return lf.p;
        }
    } else {
        Sa(n || null);
    }
};

const Pa = (t, n) => {
    if (typeof n !== "function" || !t.jt) {
        return n;
    }
    return function e(...s) {
        Ra(t);
        return n.apply(this, s);
    };
};

const qa = (t, n) => {
    const e = t.Le;
    const s = typeof t.jt === "string";
    s && !t.k && (t.k = n || na()?.k);
    if (t.resolved) {
        return;
    }
    const o = Na();
    const r = na();
    const i = e.nr();
    const c = wi(i, n => {
        t.resolved = Pa(t, n);
    });
    if (c) {
        const t = e.Et;
        Ma(t, r?.R instanceof Wi ? r?.R.node : void 0, o);
    }
    const l = s && t.k && Ra(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Aa = (t, n, e, s, o, r) => {
    const i = ((t, n, e, s, o) => new $a(t, n, e, s, o))(t, n, s, e, r);
    const c = new va(i, o, r);
    return Ta(c);
};

const Ta = t => {
    const n = async function(...t) {
        return ma.call(n, this, ...t);
    };
    n[ya] = t;
    Object.setPrototypeOf(n, _a);
    return n;
};

const Ia = /*#__PURE__*/ new Set;

const Ma = (t, n, e) => {
    if (!Ia.has(t)) {
        Ia.add(t);
        xa("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const xa = (t, n) => {
    Xd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const Na = () => {
    if (Xd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

const Ca = /*#__PURE__*/ lr("runtimeSymbolIds", () => ({
    next: 0
}));

const Oa = t => Aa(null, "s" + Ca.next++, t, null, null);

const ja = Oa;

const La = t => t;

const Fa = t => Aa("", cr, t, null, null);

const Xa = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return Aa("", cr, t, null, null);
};

const Da = t => {
    function n(n, e, s = 0) {
        const o = t.ut.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Wa] = [ t ];
        return eo(i, n, null, n.children, s, r);
    }
    n[Wa] = [ t ];
    return n;
};

const Wa = /*#__PURE__*/ or("serializable-data");

const za = t => typeof t == "function" && t[Wa] !== void 0;

const Va = t => Da(ja(t));

const Ua = Ss(La);

const Ba = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Qa = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !di(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(xr, "resumed");
    const s = Ie(t);
    s.$n = e.serverData || {};
    const o = s.rootVNode;
    Sl(o, Hi, n);
    vn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            kt(s, [], s.rootVNode);
        }
    };
};

const Ha = (t, n) => {
    const {val: e, set: s, iCtx: o} = Vo();
    if (e != null) {
        return e;
    }
    const r = er(t) ? je(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.k;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Ju(r, i, t);
        s(c);
        return c;
    }
};

const Ja = t => {
    const n = bi(t);
    return (t => t.toString(36))(n.Xe++);
};

const Ya = () => {
    const {val: t, set: n, iCtx: e} = Vo();
    if (t != null) {
        return t;
    }
    const s = e.k.De || "";
    const o = s ? qo(s).substring(0, 3) : "";
    const r = e.k.getHostProp(e.R, ar);
    const i = r?.getHash().substring(0, 3) || "";
    const c = Ja(e.k) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function De(t, n) {
    const e = na();
    return e?.k?.$n[t] ?? n;
}

const Ga = /*#__PURE__*/ new Map;

const Za = (t, n) => {
    let e = Ga.get(n);
    e || Ga.set(n, e = Ka(t, n));
    return e;
};

const Ka = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = ih;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Fh) {
            r++;
            e = Ch;
        }
        const s = Qh[c];
        for (let p = 0; p < s.length; p++) {
            const $ = s[p];
            const [y, w, _] = $;
            if ((y === l || y === ph || y === $h && th(l) || y === wh && rh(l)) && (w === e || w === ph || w === $h && th(e) || w === yh && !th(e) && e !== Ah || w === wh && rh(e))) {
                const s = r;
                if ($.length == 3 || a($)) {
                    if (c === ah && _ === oh && !h()) {
                        r = s;
                        continue;
                    }
                    $.length > 3 && (e = t.charCodeAt(r - 1));
                    if (_ === hh || _ == dh) {
                        if (_ === dh) {
                            if (c !== sh || d()) {
                                if (!nh(e)) {
                                    const t = w == yh ? 1 : w == Rh ? 2 : 0;
                                    f(r - t);
                                }
                            } else {
                                nh(e) ? u(r - 2) : f(r - 2);
                                i++;
                            }
                        }
                        if (w === yh) {
                            r--;
                            e = l;
                        }
                        do {
                            c = o.pop() || ih;
                            if (c === oh) {
                                u(r - 1);
                                i++;
                            }
                        } while (eh(c));
                    } else {
                        o.push(c);
                        if (c === oh && _ === ih) {
                            u(r - 8);
                            i = r;
                        } else {
                            _ === lh && f(n);
                        }
                        c = _;
                    }
                    break;
                }
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === oh || d()) {
            return;
        }
        u(t);
        s.push(".", pr, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === qh) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === qh) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Dh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        let n = r;
        let s = 0;
        let o = 0;
        let i = 0;
        for (;n < e; ) {
            const e = t.charCodeAt(n++);
            if (i) {
                e === Fh ? n++ : e === i && (i = 0);
            } else if (e === Sh || e === gh) {
                i = e;
            } else if (e === Th && t.charCodeAt(n) === Ph) {
                n = t.indexOf("*/", n + 1);
                if (n === -1) {
                    return !1;
                }
                n += 2;
            } else if (e === kh) {
                s++;
            } else if (e === Rh) {
                s--;
            } else if (e === jh) {
                o++;
            } else if (e === Lh) {
                o--;
            } else if (s === 0 && o === 0) {
                if (e === Vh) {
                    return !0;
                }
                if (e === Nh || e === Uh) {
                    return !1;
                }
            }
        }
        return !1;
    }
    function d() {
        return o.indexOf(oh) !== -1 || o.indexOf(uh) !== -1;
    }
};

const th = t => t >= Ih && t <= Mh || t >= Ch && t <= Oh || t >= Wh && t <= zh || t >= 128 || t === Xh || t === qh;

const nh = t => t === xh || t === Ah || t === jh || t === Eh || th(t);

const eh = t => t === ch || t === uh || t === fh || t === oh;

const rh = t => t === _h || t === vh || t === mh || t === bh;

const ih = 0;

const sh = 2;

const oh = 5;

const lh = 6;

const uh = 10;

const ch = 11;

const fh = 12;

const ah = 13;

const hh = 17;

const dh = 18;

const ph = 0;

const $h = 1;

const yh = 2;

const wh = 3;

const vh = 9;

const mh = 10;

const bh = 13;

const _h = 32;

const gh = 34;

const Eh = 35;

const Sh = 39;

const kh = 40;

const Rh = 41;

const Ph = 42;

const qh = 45;

const Ah = 46;

const Th = 47;

const Ih = 48;

const Mh = 57;

const xh = 58;

const Nh = 59;

const Ch = 65;

const Oh = 90;

const jh = 91;

const Lh = 93;

const Fh = 92;

const Xh = 95;

const Dh = 32;

const Wh = 97;

const zh = 122;

const Vh = 123;

const Uh = 125;

const Bh = /*@__PURE__*/ (() => [ [ ph, Sh, 14 ], [ ph, gh, 15 ], [ ph, Th, 16, "*" ] ])();

const Qh = /*@__PURE__*/ (() => [ [ [ ph, Ph, sh ], [ ph, jh, 7 ], [ ph, xh, lh, ":", "before", "after", "first-letter", "first-line" ], [ ph, xh, oh, "global" ], [ ph, xh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ ph, xh, 4 ], [ ph, $h, 1 ], [ ph, Ah, 1 ], [ ph, Eh, 1 ], [ ph, 64, uh, "keyframe" ], [ ph, 64, ch, "media", "supports", "container" ], [ ph, 64, fh ], [ ph, Vh, ah ], [ Th, Ph, 16 ], [ ph, Nh, hh ], [ ph, Uh, hh ], [ ph, Rh, hh ], ...Bh ], [ [ ph, yh, dh ] ], [ [ ph, yh, dh ] ], [ [ ph, kh, ih ], [ ph, yh, dh ] ], [ [ ph, kh, 8 ], [ ph, yh, dh ] ], [ [ ph, kh, ih ], [ ph, yh, hh ] ], [ [ ph, yh, hh ] ], [ [ ph, Lh, dh ], [ ph, Sh, 14 ], [ ph, gh, 15 ] ], [ [ ph, Rh, hh ], ...Bh ], [ [ ph, Uh, hh ], ...Bh ], [ [ ph, Uh, hh ], [ wh, $h, 1 ], [ ph, xh, oh, "global" ], [ ph, Vh, ah ], ...Bh ], [ [ ph, Vh, ih ], [ ph, Nh, hh ], ...Bh ], [ [ ph, Nh, hh ], [ ph, Vh, 9 ], ...Bh ], [ [ ph, Uh, hh ], [ ph, Vh, ah ], [ ph, xh, oh, "global" ], [ ph, kh, 8 ], ...Bh ], [ [ ph, Sh, hh ] ], [ [ ph, gh, hh ] ], [ [ Ph, Th, hh ] ] ])();

const Hh = t => ({
    styleId: Zh(t, t => t, !1)
});

const Jh = /*#__PURE__*/ Ss(Hh);

const Yh = t => ({
    scopeId: pr + Zh(t, Za, !0)
});

const Gh = /*#__PURE__*/ Ss(Yh);

const Zh = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Vo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${qo(t.ut)}-${n}`)(t, i);
    const l = r.R;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.k.Ze(n(t, c), c, l, e));
    }
    r.k.Ze(n(t.resolved, c), c, l, e);
    return c;
};

const Kh = (t, n) => {
    t.resolve();
    return qs(t, n);
};

const td = (t, n) => Qo(Kh, t, n);

const nd = Ss(td);

const ed = t => {
    t.resolve();
    return Ts(t);
};

const rd = t => Qo(ed, t);

const id = Ss(rd);

const sd = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Vo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Xd()) {
            e.h |= 32;
            od(e, i);
        }
        return;
    }
    let c;
    if (Xd() || i === "intersection-observer") {
        c = 1;
        Xd() || t.resolve();
    } else {
        c = 5;
        t.resolve();
        vn(r.k, r.R, 1);
    }
    const l = new Au(c, o, r.R, t, null);
    s(l);
    od(l, i);
};

const od = (t, n) => {
    n === "intersection-observer" ? Kc("qvisible", ld(t)) : n === "document-ready" ? tf("qinit", ld(t)) : n === "document-idle" && tf("qidle", ld(t));
};

const ld = t => Aa(null, "_task", Mn, null, [ t ]);

const ud = Ss(Yc);

const cd = /*#__PURE__*/ Ss(Pu);

const fd = /*#__PURE__*/ Ss(sd);

const ad = () => Object.defineProperty({
    error: void 0
}, "error", {
    enumerable: !1
});

async function Gd(t, n, e, s) {
    const o = n + "";
    const r = await e.container.P(o, e);
    t.write(`<template ${mr}="${n}"${s?.attrs ?? ""}>`);
    t.write(r.html);
    t.write("</template>");
    t.emitOutOfOrderSegmentScripts(r.scripts);
    t.emitOutOfOrderExecutorIfNeeded();
    t.emitInlineScript(`qO(${n})`);
    const i = e.container.I;
    if (__EXPERIMENTAL__.catchBoundary && i?.length) {
        t.emitErrorSwapExecutorIfNeeded();
        for (let n = 0; n < i.length; n++) {
            t.emitInlineScript(`qErr(${i[n]})`);
        }
    }
    await t.streamHandler.flush();
}

const hd = () => {
    const [t] = ga._;
    const n = na()?.k;
    const e = Ve;
    e && t && n && function s(t, n) {
        const e = t.resolveContextHost(n, Tf);
        if (!e) {
            return;
        }
        const s = me(t, e);
        if (!s) {
            return;
        }
        (function o(t, n, e) {
            let s = n;
            let o = null;
            let r = mu(n);
            let i = !1;
            for (;r; ) {
                if (_l(r)) {
                    if (El(r, $r, null) !== null) {
                        i = !0;
                    } else if (El(r, ar, null) !== null) {
                        if (!i) {
                            const n = me(t, r);
                            if (!n || n.error !== void 0) {
                                o && (s = o);
                                o = r;
                                if (n?.error !== void 0 || !k(r.props)) {
                                    break;
                                }
                            }
                        }
                        i = !1;
                    }
                }
                r = mu(r);
            }
            if (e && e !== o) {
                s = o ?? s;
                o = e;
            }
            if (o) {
                s.key = `${s.key ?? ""}${dd}`;
                vn(t, o, 4);
            } else {
                vn(t, n, 4);
            }
        })(t, e, s.projectedContentOwner ?? null);
        s.error = void 0;
    }(n, t);
};

const dd = "\0";

const pd = t => {
    if (!__EXPERIMENTAL__.catchBoundary) {
        throw Error('<Catch> requires the `catchBoundary` experimental feature. Enable it in your Qwik Vite config: qwikVite({ experimental: ["catchBoundary"] }).');
    }
    const n = (() => {
        const t = Ha(ad);
        Pf(Tf, t);
        return t;
    })();
    const e = na();
    const s = e?.k;
    s && (Vu(n) ?? n).boundaryId === void 0 && (n.boundaryId = Ja(s));
    const o = !Ve;
    if (!o && n.error === void 0) {
        return /* @__PURE__ */ no(ho, null, null, null, 0, null);
    }
    const r = /*#__PURE__*/ Mc(hd, "_caR", [ e?.R ]);
    if (o) {
        const e = t.fallback$;
        n.Mt = Ef(t => e(t, r));
        const o = t.onError$;
        o && (n.Be = Ef((t, n) => o(t, n)));
        return ((t, n) => {
            const e = n?.nextOutOfOrderId(!1) ?? 0;
            return [ 
            /*#__PURE__*/ no("div", {
                [br]: e + "",
                style: "display:contents"
            }, null, 
            /*#__PURE__*/ no(ho, null, null, null, 0, null), 1, null), 
            /*#__PURE__*/ no(tp, {
                boundaryId: e,
                store: t
            }, null, null, 1, null) ];
        })(n, s);
    }
    const i = Ud(n.error, !0);
    return /* @__PURE__ */ no(fo, null, null, ((t, n, e) => t(n, e).catch(n => {
        if (t.resolved !== void 0) {
            throw n;
        }
        return /* @__PURE__ */ no("div", {
            role: "alert"
        }, null, "Something went wrong.", 0, null);
    }))(t.fallback$, i, r), 0, null);
};

const $d = /*#__PURE__*/ Da(
/*#__PURE__*/ Mc(pd, "_caC"));

const Zd = (t, n) => {
    const e = n.Mt;
    delete n.Mt;
    const s = Ud(n.error, Ue, t.A);
    return e(s);
};

const Kd = /*#__PURE__*/ Vd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    if (n.varProps.deliverLate) {
        const n = async n => {
            if (!r.Mt) {
                return;
            }
            r.error !== n && Wf(r, n, "render");
            const s = await t.segment("" + o, Zd(t, r), e);
            s.container.C(o);
            await t.F(() => Gd(t, o, s, null));
        };
        r.Nt = Ef(n);
        t.write(`<template ${mr}="${o}"></template>`);
        if (r.error !== void 0) {
            return n(r.error);
        }
        return;
    }
    if (r.error === void 0 || !r.Mt) {
        return;
    }
    Dd(t) ? t.C(o) : s(() => {
        t.emitErrorSwapExecutorIfNeeded();
        t.emitInlineScript(`qErr(${o})`);
    });
    s(Zd(t, r));
});

const tp = 
/*#__PURE__*/ Vd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    const i = __EXPERIMENTAL__.pendingBoundary && t.outOfOrderStreaming && !Dd(t) && (r.error === void 0 || (t => Lf.has(t))(r));
    s(
    /*#__PURE__*/ no("div", {
        [i ? jd : "q:cf"]: o + "",
        style: "display:none"
    }, null, 
    /*#__PURE__*/ no(Kd, {
        boundaryId: o,
        store: r,
        deliverLate: i
    }, null, null, 1, null), 1, null));
});

const yd = async ({track: t}) => {
    const n = ga._[0];
    t(() => n.items);
    const e = na();
    const s = e.R;
    const o = e.k;
    const r = vn(o, s, 256);
    const i = ze;
    i && await r;
};

const wd = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Pu(/*#__PURE__*/ Mc(yd, "_eaT", [ t ]));
    return po;
};

const vd = /*#__PURE__*/ Da(
/*#__PURE__*/ Mc(wd, "_eaC"));

const md = (t, n, e) => fr(t) ? t.getFn(n)(e) : t(e);

const bd = ({track: t}) => {
    const n = ga._[0];
    const e = na();
    const s = e.R;
    const o = e.k;
    const r = ze;
    return wi(t(() => md(n.when$, na(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return wi(i ? md(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Bt(s, n);
            vn(o, s, 2);
        });
    });
};

const _d = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Pu(/*#__PURE__*/ Mc(bd, "_shT", [ t ]));
    return po;
};

const gd = /*#__PURE__*/ Da(
/*#__PURE__*/ Mc(_d, "_shC"));

const Ed = /*#__PURE__*/ Rf("qk-reveal");

const Sd = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Is(0)
});

const kd = () => {
    const t = ga._[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Ve) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Bd(t);
};

const Rd = ({cleanup: t}) => {
    const n = ga._[0];
    t(() => {
        if (!Ve) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Pd = t => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
    }
    const n = Qo(Sd, t);
    Pf(Ed, n);
    const e = !Ve;
    if (__EXPERIMENTAL__.pendingBoundary && e && Yd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = na().k;
                const s = (Qd.get(e) || 0) + 1;
                Qd.set(e, s);
                return new Hd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = Ef(e);
            return e;
        })(n);
        return /* @__PURE__ */ no(np, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    return /* @__PURE__ */ no(ho, null, null, null, 0, "u7_0");
};

const qd = /*#__PURE__*/ Da(
/*#__PURE__*/ Mc(Pd, "_reC"));

const np = /*#__PURE__*/ Vd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ no(ho, null, null, null, 0, "u7_0"));
});

const Ad = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback$ == null || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const ep = '{display:p1.value==="fallback"&&p0.fallback$!=null&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Td = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const Id = ({track: t, cleanup: n}) => {
    const e = ga._[0], s = ga._[1], o = ga._[2], r = ga._[3];
    const i = t(e);
    const c = Ve;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Md = t => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        throw Error('Pending is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
    }
    const n = Bo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.pendingBoundary) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
        }
        return Bo(0);
    })();
    const s = (t => {
        const n = qf(Ed, null);
        const e = Qo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Pu(/*#__PURE__*/ Mc(Rd, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = td(
    /*#__PURE__*/ Mc(kd, "_reR", [ s ]));
    Pu(
    /*#__PURE__*/ Mc(Id, "_peT", [ e, t, n, s ]));
    const r = !Ve;
    const i = r && Yd();
    const c = i ? (() => na().k.nextOutOfOrderId())() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && sa(() => t.fallback$ != null) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Dc(Td, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = t.fallback$ ? t.fallback$.getFn(na())() : null;
    const p = i ? /*#__PURE__*/ no(sp, {
        boundary: f,
        fallbackStyle: Dc(Ad, [ t, n, o, s ], ep),
        showFallback: u,
        state: n
    }, null, d, 1, null) : /*#__PURE__*/ no("div", {
        style: Dc(Ad, [ t, n, o, s ], ep)
    }, null, d, 1, null);
    return [ p, 
    /*#__PURE__*/ no("div", null, i ? {
        [jd]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ no(i ? op : ho, i ? {
        [Kr]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Kr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const xd = /*#__PURE__*/ Da(
/*#__PURE__*/ Mc(Md, "_peC"));

const sp = /*#__PURE__*/ Vd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.fallbackStyle;
    const i = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    i && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.F(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ no("div", {
        style: r
    }, null, n.children, 1, null));
});

const op = /*#__PURE__*/ Vd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = __EXPERIMENTAL__.catchBoundary && e.parentComponentFrame ? t.resolveContext(e.parentComponentFrame.componentNode, Tf) : void 0;
    const u = t.segment(o, function f(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            return /* @__PURE__ */ no(ho, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = R(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        return /* @__PURE__ */ no(ho, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${mr}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(u.then(n => async function e(t, n, s, o, r, i) {
        if (i) {
            i.contentResolved = !0;
            if (i.delayTimer) {
                clearTimeout(i.delayTimer);
                i.delayTimer = null;
            }
        }
        r?.resolve();
        await t.F(async () => {
            t.addRoot(o);
            await Gd(t, n, s, r);
        });
    }(t, s, n, i, c, r)).catch(t => {
        if (l?.Nt) {
            return l.Nt(t);
        }
        if (l?.error !== void 0) {
            return;
        }
        throw t;
    }));
});

const Nd = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Cd.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return no("script", null, o, null, 0, "prefetch-service-worker");
};

const Cd =  "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Od = () => null;

export { Oa as $, $d as Catch, vd as Each, fo as Fragment, Sf as NoSerializeSymbol, xd as Pending, Od as PrefetchGraph, Nd as PrefetchServiceWorker, ao as RenderOnce, Gc as Resource, qd as Reveal, yo as SSRComment, $o as SSRRaw, vo as SSRStream, wo as SSRStreamBlock, kf as SerializerSymbol, gd as Show, po as SkipRender, ho as Slot, Ki as _CONST_PROPS, Zf as _DomContainer, _i as _EFFECT_BACK_REF, Ur as _ELEMENT_SEQ, ss as _EMPTY_ARRAY, os as _EMPTY_OBJ, rs as _IMMUTABLE, Wc as _SharedContainer, Ds as _SubscriptionData, oc as _SubscriptionPatch, Au as _Task, is as _UNINITIALIZED, ts as _VAR_PROPS, re as _addProjection, pd as _caC, hd as _caR, Ea as _captures, ga as _capturesObj, m as _chk, we as _createDeserializeContainer, Aa as _createQRL, Nn as _createStore, vi as _delay, $e as _deserialize, Ec as _dumpState, wd as _eaC, yd as _eaT, yn as _executeSsrChores, Dc as _fnSignal, ds as _getConstProps, aa as _getContextContainer, fa as _getContextEvent, ca as _getContextHostElement, Ie as _getDomContainer, xe as _getQContainerElement, ur as _getSingleton, w as _getSubscriber, hs as _getVarProps, Yn as _handleSSRError, k as _hasSlotProps, Bu as _hasStoreEffects, sf as _hmr, Ps as _injectAsyncSignalValue, je as _invoke, Us as _isJSXNode, Hu as _isStore, Un as _isStringifiable, Tu as _isTask, ha as _jsxBranch, ro as _jsxC, so as _jsxQ, io as _jsxS, no as _jsxSorted, eo as _jsxSplit, ci as _mapApp_findIndx, ai as _mapArray_get, fi as _mapArray_set, Xu as _markSignalAsExternallyOwned, Xe as _newInvokeContext, xc as _noopQrl, Nc as _noopQrlDEV, Md as _peC, Id as _peT, Wn as _preprocessState, Xa as _qrlSync, Ln as _qrlToString, Cc as _qrlWithChunk, Oc as _qrlWithChunkDEV, or as _qwikSymbol, Pd as _reC, kd as _reR, Rd as _reT, Xc as _regInlinedQrl, Fc as _regSymbol, lr as _registerSingleton, oe as _removeProjection, b as _res, Af as _resolveContextWithoutSequentialScope, So as _restProps, t as _retryOnPromise, Jc as _rsc, C as _run, pe as _serialize, te as _setEvent, ie as _setProjectionTarget, _d as _shC, bd as _shT, Mn as _task, se as _updateProjectionProps, ee as _useHmr, v as _val, vf as _verifySerializable, ql as _vnode_ensureElementInflated, wu as _vnode_getAttrKeys, Yl as _vnode_getElementName, Kl as _vnode_getFirstChild, El as _vnode_getProp, Cl as _vnode_getVNodeForChildNode, Ul as _vnode_insertBefore, wl as _vnode_isElementVNode, ml as _vnode_isMaterialized, bl as _vnode_isTextVNode, _l as _vnode_isVirtualVNode, $l as _vnode_newVirtual, Hl as _vnode_remove, Sl as _vnode_setProp, kn as _vnode_toString, da as _waitUntilRendered, Qn as _walkJSX, js as _wrapProp, Fs as _wrapSignal, Va as component$, Da as componentQrl, As as createAsyncQrl, Ms as createComputed$, qs as createComputedQrl, Rf as createContextId, _ as createElement, xs as createSerializer$, Ts as createSerializerQrl, Is as createSignal, Ua as event$, La as eventQrl, Uu as forceStoreEffects, Ba as getClientManifest, Ie as getDomContainer, Ce as getLocale, ui as getPlatform, _ as h, Ss as implicit$FirstArg, Mc as inlinedQrl, Lc as inlinedQrlDEV, Ue as isDev, Mu as isSignal, lo as jsx, uo as jsxDEV, co as jsxs, Ef as noSerialize, Ic as qrl, jc as qrlDEV, Qa as render, li as setPlatform, Fa as sync$, sa as untrack, Qu as unwrapStore, nd as useComputed$, td as useComputedQrl, Qo as useConstant, qf as useContext, Pf as useContextProvider, Ya as useId, Hc as useLexicalScope, Kc as useOn, tf as useOnDocument, nf as useOnWindow, ud as useResource$, Yc as useResourceQrl, id as useSerializer$, rd as useSerializerQrl, De as useServerData, Bo as useSignal, Ha as useStore, Jh as useStyles$, Hh as useStylesQrl, Gh as useStylesScoped$, Yh as useStylesScopedQrl, cd as useTask$, Pu as useTaskQrl, fd as useVisibleTask$, sd as useVisibleTaskQrl, Qe as version, Oe as withLocale };
